import React, { Component } from 'react';
import {
    Layout, Page, Button, Modal, BlockStack, Card, Collapsible, Icon, Badge,
    Text,
    TextField,
    Tooltip,
    Checkbox,
    Banner,
    InlineGrid,
    Link,

} from '@shopify/polaris';
import { withRouter } from 'react-router-dom';
import 'react-circular-progressbar/dist/styles.css';
import {
    ChevronDownMinor,
    ChevronUpMinor,
    ChevronRightMinor,
    CancelMajor,
    // CircleTickMajor,
} from '@shopify/polaris-icons';
import './index.css';
import './index.scss';
import SkeltonLoading from "../../../../components/SkeltonLoading";
import {
    reqGetNewUserPricingPlanList,
    reqGetSubscription,
    reqGetSubscriptionCancel,
    reqUpdateUserPricingPlan,
    reqPlanConversion,
    reqAppApplicationCharge,
    reqGetPricingCouponData,
    reqGetSiteSpeedUp,
    reqSaveSwitchState,
    reqReviewTipsClick,
    reqGetHomeCommonData,

} from '../../../../api';
import { connect } from 'react-redux'
import { setPublicData, setSaveSwitchData } from '../../../../redux/actions/getAppPublicData';
import { setPageData } from '../../../../redux/actions/getAppPageData';
import utils from '../../../../utils/utils';
import Language from '../../../../i18n/Language';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css'; // 公共引入轮播图样式
import 'swiper/css/bundle'; // 公共引入轮播图样式

import cloneDeep from 'lodash-es/cloneDeep';
import FaqCardBox from '../../../../components/FaqCardBox';
import SpeedBasicIcon from '../../../../assets/SpeedUp/SpeedBasicIcon';
import SpeedFastIcon from '../../../../assets/SpeedUp/SpeedFastIcon';
import SpeedRocketIcon from '../../../../assets/SpeedUp/SpeedRocketIcon';
import { store } from '../../../../redux/store';
import FooterTrustHelp from '../../../../components/FooterTrustHelp';
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Language;

let premArr = [], promArr = [], preyArr = [], proyArr = [];
class Pricing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingPage: true,
            paidLoading: false,

            //优惠价格方案
            expired_time: '00:00:00',
            milli_second: '00',

            //useType为1 默认显示年费
            userType: 0,

            //价格方案列表
            pricingPlanList: [],

            //按钮点击触发
            onButtonType: 0,

            //点击改变背景颜色状态
            selectId: 0,

            //选中等级
            selectLevel: 0,

            //升降级弹窗
            modalData: {},
            openModalChange: false,
            openModalLoading: false,

            //优惠券数据
            showCouponData: false,

            //freePlanDegrade降级弹窗
            openFreePlanDegrade: false,

            // tab滑块移动动画
            moveAnimation: 1,

            // 价格详细信息按钮状态
            pricingDetailBtnStatus: false,

            // 克隆价格详情对比
            cloneDetailCompare: {},
            clonePricingPlanList: {},

            // 是否开启sticky粘性布局
            isSticky: false,

            // 监听页面宽度
            wInnerWidth: window.innerWidth,

            // 对应套餐版本
            prePlanTitle: 'Pre Plan',
            proPlanTitle: 'Pro Plan',
            freePlanTitle: 'Free',

            // pro pre套餐id
            prePlanId: '-',
            proPlanId: '-',
            freePlanId: '-',

            // pre pro free 套餐价格
            prePlanPrice: 0,
            prePlanDiscountPrice: 0,
            proPlanPrice: 0,
            proPlanDiscountPrice: 0,
            freePlanPrice: 0,

            // pre 按钮状态 + 文字
            prePlanBtnStatus: 0, // 0不可见 1UPGREADE 2RENEWAL 3DEGRADE
            // pro 按钮状态 + 文字
            proPlanBtnStatus: 0, // 0不可见 1UPGREADE 2RENEWAL 3DEGRADE
            // free 按钮状态 + 文字
            freePlanBtnStatus: 0, // 0不可见 1UPGREADE 2RENEWAL 3DEGRADE
            language: 'en',
            pricingData: {}, // 价格页套餐总数据
            userInfo: {},
            old_button: 0, // 是否旧版付费用户
            services: {},  // 等级特性
            SerSort: {
                serTitle: {
                    "SEO Checker": {
                        title: "SEO Checker",
                        tips: 'Analyze the SEO factors of each page on the website and give suggestions for improvement.',
                        subText: {
                            "SEO Checker Scan": "SEOChecker"
                        }
                    },
                    "Site Speed Up": {
                        title: "Site Speed Up",
                        tips: 'Enable to optimize Google PageSpeed and improve website loading speed to lead to higher engagement and better user satisfaction. View more',
                        subText: {
                            "Site Speed Up": "SiteSpeedUp",
                        }
                    },
                    "Instant Page": {
                        title: "Instant Page",
                        tips: 'Improve link redirection speed for easier customer access when clicking target links.',
                        subText: {
                            "Instant Page": "InstantPage",
                        }
                    },
                    "Image Optimization": {
                        title: "Image Optimization",
                        tips: 'Images compression, alt text, file rename, and add water mark.',
                        subText: {
                            "Auto image compress": "auto_img_ompress_num",
                            "Image Alt Text": "ImageAltText",
                        }
                    },
                    "AMP": {
                        title: "AMP",
                        tips: 'Improve your site loading speed on mobile.',
                        subText: {
                            "Publish AMP page": "AMP",
                        }
                    },
                    "On-Page SEO": {
                        title: "On-Page SEO",
                        tips: 'Detect SEO issues on every page.',
                        subText: {
                            "On-Page SEO Scan": "SEOChecker",
                            "On-page SEO Optimization": "pageseo_num",
                        }
                    },
                    "AI Writer": {
                        title: "AI Writer",
                        tips: 'Help you automatically generate/optimize content that complies with SEO rules.',
                        subText: {
                            "AI Writer credits": "gift_points",
                        }
                    },
                    "Index/No Index": {
                        title: "Index/No Index",
                        tips: 'Controls whether search engines can find this page.',
                        subText: {
                            "Index/No Index Meta Robots Setting": "IndexNoIndexMetaRobotsSetting",
                        }
                    },
                    "Dofollow/Nofollow": {
                        title: "Dofollow/Nofollow",
                        tips: 'Controls whether search engine can follow the links on this page.',
                        subText: {
                            "Dofollow/Nofollow -Meta Robots Settings": "DofollowNofollowMetaRobotsSettings",
                        }
                    },
                    "Meta Tag": {
                        title: "Meta Tag",
                        tips: 'Adding the meta title/original description of the page can help search engines better understand the content of your page.',
                        subText: {
                            "Bulk Edit Meta Tags": "BulkEditMetaTags",
                            "Auto add Meta Tags": "BulkEditMetaTags",
                            "Bulk Optimize Meta Tags": "BulkEditMetaTags",
                        }
                    },
                    "Google Structured Data - Snippets": {
                        title: "Google Structured Data - Snippets",
                        tips: 'Implement JSON LD to provide search crawlers such as Googlebot with more easily indexable content.',
                        subText: {
                            "Rich snippets results test": "RichSnippetsResultsTest",
                            "Google Structured Data": "JSONLDStructuredDataSetup",
                        }
                    },
                    "Local Business": {
                        title: "Local Business",
                        tips: 'Enhance your online presence and improve local search rankings with the effective implementation of Local Business JSON-LD, making it easier for potential customers to find and contact your business.',
                        subText: {
                            "Local Business": "LocalBusiness",
                        }
                    },
                    "Instant Index": {
                        title: "Instant Index",
                        tips: "Instant indedx can quickly inform Google of pages added or removed from a site, which is useful for sites that are frequently updated.",
                        subText: {
                            "Instant Index": "InstantIndex",
                        }
                    },
                    "HTML Sitemap": {
                        title: "HTML Sitemap",
                        tips: 'It makes it easier for search engines to crawl and index your site, and for users to find the information they need. Setup html sitemap',
                        subText: {
                            "HTML sitemap": 1,
                        }
                    },
                    "Broken Links": {
                        title: "Broken Links",
                        tips: 'Automatic detection and repair broken link.',
                        subText: {
                            "Auto scan broken links": "AutoScanBrokenlinks",
                            "Daily missing page reports": "DailyBrokenlinkMissingpageReports",
                            "Bulk import and export broken link": "BulkImportAndExportBrokenLink",
                            "Auto fix broken links": "AutoFixBrokenLinks",
                        }
                    },
                    "Backlink": {
                        title: "Backlink",
                        tips: 'Increase your backlinks by exchanging links with other quality websites. Improve your website authority and search engine rankings.',
                        subText: {
                            "Backlink Audit": "BacklinkAudit",
                            "Exchange backlink quota": "ExchangeBacklinkQuota",
                        }
                    },
                    "Keywords": {
                        title: "keywords",
                        tips: 'Monitor competing products/own website keyword content and rankings.',
                        subText: {
                            "Keyword Suggestion tool": "KeywordSuggestionTool",
                            "Keywords Explore": "KeywordSuggestionTool",
                            "Rank Tracking": "MyWebsiteKeywords",
                            "Competitor's keywords": "keywords_month_num",
                            "Keyword gap with competitors": "KeywordsCompetitors",
                            // "Keyword List": "keywords_num",
                            // "View page ranking": "keywords_ranking_num"
                        }
                    },
                    "Google Analytics": {
                        title: "Google Analytics",
                        tips: 'GSC monitors your site performance in the SERPs, such as backlinks, indexing, and rankings.You can identify room for improvement and your site for higher visibility.',
                        subText: {
                            "Connect to Google Search Console": "GoogleSearchConsole",
                        }
                    },
                    "Support": {
                        title: "Support",
                        tips: 'test',
                        subText: {
                            "Livechat": "support",
                        }
                    },

                }
            },
            // Instant Page
            // Instant Page

            // JSON-LD
            // Google Structured Data - Snippets

            // Local Business
            // Local Business
            pricingStateArr: [
                "", "Pre plan", "Pro plan", "Free plan"
            ],
            isShowPricingState: false,
            oldPayModalStatus: false,
            paidDisabled: false, // 按钮置灰
            paidBtnLoading: '',
            preVersionLevel: '',
            proVersionLevel: '',
            isPreJump: false, // 是否提示pre版本

            upShowCredits: false, // 积分面板展示状态
            creditsList: [],
            purBtnStatus: false, // 积分按钮状态
            curPurId: -1, // 对应按钮loading

            isMonthOrYear: 1, // 默认选择月
            preDiscountPrice: 0, // pre优惠活动价
            proDiscountPrice: 0, // pro优惠活动价
            preMonthCountDown: 0, // pre 优惠活动倒计时
            proMonthCountDown: 0, // pro 优惠活动倒计时
            preMonthCountDown_mills: 0, // pre 优惠活动倒计时
            proMonthCountDown_mills: 0, // pro 优惠活动倒计时
            preYearCountDown: 0, // pre 优惠活动倒计时
            proYearCountDown: 0, // pro 优惠活动倒计时
            preYearCountDown_mills: 0, // pre 优惠活动倒计时
            proYearCountDown_mills: 0, // pro 优惠活动倒计时
            preMonthPeriod: 0, // pre折扣周期
            proMonthPeriod: 0, // pro折扣周期
            preYearPeriod: 0, // pre折扣周期
            proYearPeriod: 0, // pro折扣周期

            userAvator: ['user1', 'user2', 'user3', 'user4', 'user5'], // 用户头像
            logoIcon: ['shein', 'dj', 'banggood', 'medifyair', 'luxskin', 'relx'], // logo
            FreeTrialStatus: true,
            BillingCycleStatus: true,
            discountVal: '',
            discountValError: '',
            disBtnLoading: false, // 折扣码按钮loading
            isShowDisTicket: false,
            discountRate: 1,
            preMRecode: '', // 折扣码
            proMRecode: '',
            preYRecode: '',
            proYRecode: '',

            isShowExtraGift: false,
            appGiftList: {
                "Trustoo": {
                    title: "Trustoo Product & Ali Reviews",
                    desc: "Import products reviews from Ali and Amazon",
                    price: 20,
                    img: '/extra_app/Trustoo.png',
                    tip: "Contact Trustoo's 24/7 customer service to get it for free.",
                    url: 'https://share.channelwill.com/app/21657ab1f4e2d70ixV'
                },
                "Loyalty": {
                    title: "LL: Loyalty Rewards Referrals",
                    desc: "Boost sales with loyalty rewards & referral programs.",
                    price: 69,
                    img: '/extra_app/Loyalty.png',
                    tip: "Contact Loyalty's 24/7 customer service to get it for free.",
                    url: 'https://share.channelwill.com/app/3365704d41c93515ho'
                },
                "Parcel": {
                    title: "Parcel Panel Insurance",
                    desc: "Boost revenue with your shipping protection solution",
                    price: 11,
                    img: '/extra_app/Parcel.png',
                    tip: "After install Parcel Panel Insurance you will get it for free.",
                    url: 'https://insurance.parcelpanel.com/recommend/Seo-ant'
                },
                "Willdesk": {
                    title: "Willdesk‑Live Chat, Helpdesk, Chatbot",
                    desc: "Turn customer service into a profit center.",
                    price: 30,
                    img: '/extra_app/Willdesk.png',
                    tip: "Contact Willdesk's 24/7 customer service to get it for free.",
                    url: 'https://share.channelwill.com/app/12657ab5047de8dM29'
                },
                "RecomSale": {
                    title: "RecomSale: Referral & Affiliate Marketing",
                    desc: "Boost your sales with affiliate, referral & ambassador program",
                    price: 29,
                    img: '/extra_app/RecomSale.png',
                    tip: "After install Recomsale you will get it for free.",
                    url: 'https://app.recomsale.com/affiliate-share?rs_source=seoant'
                },
            },
            isShowGiftBlock: false,
            onlineGiftTiem: 1703174400, // 上线时间
            googleState: false, // 是否开启加速
            loadingSpeed: true,
            cDays: '00',
            cHours: '00',
            cMins: '00',
            cSecs: '00',
            diyBannerState: -1, // banner自定义状态
            planName: '', // 活动名称
            isHaveDiscount: false,   // 是否存在折扣
            isShowFiveModal: false,
            isShowFeedback: false, // 反馈弹窗
            isShowReasonSet: false,
            isShowUpdateSet: false,
            updateFeedback: '',     // 反馈输入框
            notExpectVal: false,
            poorVal: false,
            lackVal: false,
            performVal: false,
            securityVal: false,
            expensiveVal: false,
            softwareVal: false,
            othersVal: false,
            notExpectInfoVal: '',
            poorInfoVal: '',
            lackInfoVal: '',
            performInfoVal: '',
            securityInfoVal: '',
            expensiveInfoVal: '',
            softwareInfoVal: '',
            othersInfoVal: '',
            isShowWarnFeedback: "",
            codeFocus: false, // 折扣码聚焦
            iscacheLoading: true, // 缓存状态
            userReviewArr: {
                0: [
                    {
                        id: 1,
                        user: "Daniel Johnson",
                        desc: "Excellent app. It definitely did more for my site than the other SEO optimizer I had been using. Also, they have great support who was both friendly and helpful. Highly recommended.",
                        state: "United States",
                        img: "/userSuccessStories/avatar1.png",
                    },
                    {
                        id: 2,
                        user: "James Wilson",
                        desc: "This app is great if you don't know to much about SEO , it'll walk you through the stages to optimize your without the need to hire expensive freelancers. I would thoroughly recommend it !!",
                        state: "United Kingdom",
                        img: "/userSuccessStories/avatar2.png",
                    },
                    {
                        id: 3,
                        user: "Isabella Brown",
                        desc: "This app is great if you don't know to much about SEO , it'll walk you through the stages to optimize your without the need to hire expensive freelancers. I would thoroughly recommend it !!",
                        state: "New Zealand",
                        img: "/userSuccessStories/avatar3.png",
                    },
                ],
                1: [
                    {
                        id: 4,
                        user: "Michael Smith",
                        desc: "This app has made it very easy to optimize our website as a group of people who know nothing about SEO! We highly recommend it!",
                        state: "United States",
                        img: "/userSuccessStories/avatar4.png",
                    },
                    {
                        id: 5,
                        user: "Emma Thompson",
                        desc: "This is the most useful, underrated Shopify App that I have ever found. I appreciate it. Omg, I am thrilled! Definitely recommended for people who struggle with SEO optimisation, meta, alt text etc. It's easy, full of advice and automation.",
                        state: "United Kingdom",
                        img: "/userSuccessStories/avatar5.png",
                    },
                    {
                        id: 6,
                        user: "Liam Williams",
                        desc: "Best chat Support, very helpful, all SEO on-page factors show in-app, with sitemap and schema functionality.",
                        state: "New Zealand",
                        img: "/userSuccessStories/avatar6.png",
                    },
                ]
            },
            swiperInx: 1,
            isAsFree: false, // 是否新用户 必须选择版本
            asFreeLoading: false, // 免费按钮loading
            preDiscount: 1,
            proDiscount: 1,
            questionList: {
                h_does_trial: {
                    title: "How does the Free Trial work?",
                    tag: ["You can try SEOAnt for free for 7 days and easily cancel at any time with just one click. If you choose to uninstall or downgrade to the free plan during your trial, you will not be charged."]
                },
                c_myplan: {
                    title: "Can I change my plan in the middle of a billing cycle?",
                    tag: ["Yes, you can change your plan anytime based on your needs, the charge is prorated based on the difference in price and the number of days remaining in the billing cycle."]
                },
            },
            isComboUser: false,     // 是否组合套餐用户
            isShowCwComboModal: false,
            isActLoading: true,
            isShowCouponDis: false,   // 是否展示优惠券的布局

            newPlanService: {
                "SEO Checker": {
                    "SEO Checker Scan": [true, true, true],
                    "other": {
                        "desc": "Analyze the SEO factors of each page on the website and give suggestions for improvement.",
                    },
                },
                "Site Speed Up": {
                    "Site Speed Up": [true, true, true],
                    "other": {
                        "desc": "Enable to optimize Google PageSpeed and improve website loading speed to lead to higher engagement and better user satisfaction.",
                        "subdesc": "View more",
                        "url": "/speedOpt/site-speedup",
                        isSub: true,
                    },
                },
                "Instant Page": {
                    "Instant Page": [true, true, true],
                    "other": {
                        "desc": "Improve link redirection speed for easier customer access when clicking target links.",
                    },
                },
                "Image Optimization": {
                    "Auto image compress": [50, 2000, 6000],
                    "Image Alt Text": [true, true, true],
                    "other": {
                        "desc": "Images compression, alt text, file rename, and add water mark.",
                        "unit": "images",
                        isMonth: true
                    },
                },
                "AMP": {
                    "Publish AMP page": ['--', '--', true],
                    "other": {
                        "desc": "Improve your site loading speed on mobile.",
                    },
                },
                "Content Optimization": {
                    "All Pages SEO Scan": [true, true, true],
                    "On-page SEO Optimization": [20, 1000, -1],
                    "AI Writer credits": [30, 200, 500],
                    "other": {
                        "desc": "Detect SEO issues on every page.",
                        "unit": "quota",
                        "ai_unit": "credits",
                        isMonth: false,
                        isAiMonth: true,
                    }
                },
                // "AI Writer": {
                //     "AI Writer credits": [30, 200, 500, 1000],
                //     "other": {
                //         "desc": "Help you automatically generate/optimize content that complies with SEO rules.",
                //         "unit": "credits",
                //         isMonth: true
                //     },
                // },
                "Index/No Index": {
                    "Index/No Index Meta Robots Setting": ['--', true, true],
                    "other": {
                        "desc": "Controls whether search engines can find this page.",
                    },
                },
                "Dofollow/Nofollow": {
                    "Dofollow/Nofollow -Meta Robots Settings": ['--', true, true],
                    "other": {
                        "desc": "Controls whether search engine can follow the links on this page.",
                    },
                },
                "Meta Tag": {
                    "Bulk Edit Meta Tags": ['--', true, true],
                    "Auto add Meta Tags": ['--', true, true],
                    "Bulk Optimize Meta Tags": ['--', true, true],
                    "other": {
                        "desc": "Adding the meta title/original description of the page can help search engines better understand the content of your page.",
                    },
                },
                "Google Structured Data - Snippets": {
                    "Rich snippets results test": [true, true, true],
                    "Google Structured Data": ['--', true, true],
                    "other": {
                        "desc": "Implement JSON LD to provide search crawlers such as Googlebot with more easily indexable content.",
                    },
                },
                "Local Business": {
                    "Local Business": ['--', true, true],
                    "other": {
                        "desc": "Enhance your online presence and improve local search rankings with the effective implementation of Local Business JSON-LD, making it easier for potential customers to find and contact your business.",
                    },
                },
                "Instant Index": {
                    "Instant Index": ['--', true, true],
                    "other": {
                        "desc": "Instant indedx can quickly inform Google of pages added or removed from a site, which is useful for sites that are frequently updated.",
                    },
                },
                "HTML Sitemap": {
                    "HTML Sitemap": [true, true, true],
                    "other": {
                        "desc": "It makes it easier for search engines to crawl and index your site, and for users to find the information they need.",
                        "subdesc": "Setup html sitemap",
                        "url": "/backlinks/html-sitemap",
                        isSub: true,
                    },
                },
                "Broken Links": {
                    "Auto scan broken links": [true, true, true],
                    "Daily missing page reports": ['--', true, true],
                    "Bulk import and export broken link": ['--', true, true],
                    "Auto fix broken links": ['--', true, true],
                    "other": {
                        "desc": "Automatic detection and repair broken link.",
                    },
                },
                "Backlink": {
                    "Backlink Audit": ['--', '--', true],
                    "Exchange backlink quota": [40, 300, 1000],
                    "other": {
                        "desc": "Increase your backlinks by exchanging links with other quality websites. Improve your website authority and search engine rankings.",
                    },
                },
                "Keywords": {
                    "Keyword Suggestion tool": [true, true, true],
                    "Keywords Explore": [true, true, true],
                    "Rank Tracking": ['--', '--', true],
                    "Competitor's keywords": ['--', '--', 10],
                    "Keyword gap with competitors": ['--', '--', true],
                    // "Keyword List": ['--', '--', 1000, 1000],
                    // "View page ranking": [10, 500, 1500, 1500],
                    "other": {
                        "desc": "Monitor competing products/own website keyword content and rankings.",
                        "unit-cwkm": "website",
                        "unit-kl": "",
                        "unit-vpr": "pages",
                        isMonth: true
                    },
                },
                "Google Analytics": {
                    "Connect to Google Search Console": ['--', true, true],
                    "other": {
                        "desc": "GSC monitors your site performance in the SERPs, such as backlinks, indexing, and rankings.You can identify room for improvement and your site for higher visibility.",
                        "subdesc": "Connect",
                        "url": "/searchAppearance/GoogleSearchConsoleV2",
                        isSub: true,
                    },
                },
                "Support": {
                    "Livechat": ['Daily', '24/7', 'VIP Priority'],
                    "Expert Consultation": ['--', '--', '--'],
                    "other": {
                        "desc": "",
                    },
                },
            },              // 服务清单列表
            expertPlanBtnStatus: 0,     // 专家服务 按钮状态
            isShowAiDouble: false,      // 是否补偿用户
            aiDoubleDate: 0,            // 补偿到期时间
            mTabBtnWidth: 0,
            yTabBtnWidth: 0,

            ai_buy_status: false,       // ai购买状态
            annualDisText: "",              // 默认20折扣
            defalutDis: 0.8,        // 默认折扣
        }
        this.swiperRef = React.createRef();
    }

    UNSAFE_componentWillMount() {
        // 等待活动数据 判断是否展示黑五
        store.subscribe(() => {
            let actInfo = store.getState().public.ActMealData;
            if (Object.keys(actInfo).length > 0) {
                this.setState({
                    isActLoading: false,
                    planName: actInfo?.plan_name || '',
                })
            }
        })
        // 重置活动gif块状态
        if (window.giftEvent) {
            window.giftEvent.changeActMealModal();
        }
    }

    //进入页面调用接口
    componentDidMount() {
        // 查看自定义状态
        let headData = this.props.public.publicInit.head_data;
        let stateS = headData?.switch_data;
        this.setState({
            diyBannerState: typeof stateS === 'boolean' ? true : !Boolean(stateS?.pricingTimeBanner),
            isAsFree: typeof stateS === 'boolean' ? false : (Boolean(stateS?.select_version) ? Boolean(Number(stateS?.select_version?.st) === 0) : false),
            isComboUser: Boolean(headData?.is_combo_plan),
        }, () => {
            // 获取套餐版本
            let _page = this.props.page;
            this.getUserPricingPlanList(false, _page.pageInit?.pricingPlan);

            // pre跳转高亮
            if (Boolean(this.props.location.query) && this.props.location.query === 'Pre Plan') {
                this.setState({
                    isPreJump: true,
                }, () => {
                    // this.hightLightPlan();
                })
            }
        })

        // 监听更新
        store.subscribe(() => {
            let _headData = store.getState().public.publicInit.head_data;
            let _stateS = _headData?.switch_data;
            this.setState({
                diyBannerState: typeof _stateS === 'boolean' ? true : !Boolean(_stateS?.pricingTimeBanner),
                isAsFree: typeof _stateS === 'boolean' ? false : (Boolean(_stateS?.select_version) ? Boolean(Number(_stateS?.select_version?.st) === 0) : false),
                isComboUser: Boolean(_headData?.is_combo_plan),
            })
        })
    }

    // 获取pagespeed状态
    getPageSpeedStatus = async () => {
        const res = await reqGetSiteSpeedUp();
        if (res) {
            let { SerSort } = this.state;
            let newSort = cloneDeep(SerSort);
            if (!Boolean(res?.status)) {
                delete newSort.serTitle["Site Speed Up"]
            }
            this.setState({
                googleState: !Boolean(res?.status),
                loadingSpeed: false,
                SerSort: newSort
            })
        }
    }

    // 增加pre版本高亮
    hightLightPlan = () => {
        if (Boolean(document.getElementById('pricingMealContent')) && Boolean(document.getElementById('pricingMealContent').childNodes[0].childNodes[0])) {
            document.getElementById('pricingMealContent').childNodes[0].childNodes[0].style.boxShadow = '0 -3px 20px #999999';
            setTimeout(() => {
                if (Boolean(document.getElementById('pricingMealContent')) && Boolean(document.getElementById('pricingMealContent').childNodes[0].childNodes[0])) {
                    document.getElementById('pricingMealContent').childNodes[0].childNodes[0].style.boxShadow = 'unset';
                }
            }, 2000)
        } else {
            setTimeout(() => {
                this.hightLightPlan();
            }, 100)
        }
    }

    // 获取价格套餐版本
    getUserPricingPlanList = async (showFeedback = false, cache = null) => {
        let params = {};
        if (Object.keys(this.props.public.ActMealData).length > 0) {
            params['activity_id'] = this.props.public.ActMealData.activity_id;
        }
        let response = cache || await reqGetNewUserPricingPlanList(params);
        this.props.getPageDataRedux(response);
        if (response.ack === 1) {
            let res = response.data;
            // res.level = 1;
            //如果用户是免费套餐则默认选中pro半年费
            let selectId = res.level <= 1 ? 6 : res.ppid;
            let originSer = cloneDeep(res.services);
            console.log(originSer);
            
            Object.keys(originSer).forEach(item => {
                originSer[item] = { ...originSer[item], ...originSer[item].services }
            })
            // this.verifyGift(res.activated_on); // 验证是否有福利app

            // 计算年费折扣
            let annualDisText = this.computeAnnualDiscount(res.meal_list.year);
            this.setState({
                iscacheLoading: cache || false,
                pricingPlanList: res.meal_list,
                selectId: selectId,
                selectLevel: res.level + "",
                loading: false,
                loadingPage: false,
                level: res.level,
                pricingData: res,
                userInfo: {
                    ppid: res.ppid,
                    level: res.level,
                    trial_days: res.trial_days
                },
                old_button: res.old_button,
                services: res.services,
                SerSort: { ...this.state.SerSort, ...originSer },
                creditsList: res.points,
                planName: this.props.public.ActMealData.plan_name || '',
                isHaveDiscount: res.coupon_fifty_discount,   // 是否存在折扣

                isShowAiDouble: res.ai_points_bills_gift_exp === 0 ? false : true,
                aiDoubleDate: res.ai_points_bills_gift_exp,
                ai_buy_status: res.ai_buy_status,
                defalutDis: res.meal_list.year[0]?.default_discount || 0.8,
                annualDisText,
            }, () => {
                // if (res.trial_days > 0 && res.trial_days <= 30) {
                //     //设置倒计时
                //     let day_time = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000);
                //     this.countdown(day_time)
                // }

                // 获取按钮宽度
                this.setTabPlanBtnWidth();

                // 判断当前用户等级 移动滑块
                let userInfo = this.state.userInfo
                if (userInfo.ppid === 2 || userInfo.ppid === 4 || userInfo.ppid === 10) {
                    this.move(1)
                    this.setState({
                        prePlanId: 4,
                        proPlanId: 2
                    })
                } else if (userInfo.ppid === 8 || userInfo.ppid === 9 || userInfo.ppid === 10) {
                    this.move(2)
                    this.setState({
                        prePlanId: 9,
                        proPlanId: 8
                    })
                } else {
                    this.move(1)
                }

                // 判断是否过来购买积分
                const _params = this.props.location;
                if (Boolean(_params.query)) {
                    if (_params.query === 'pay_credits') {
                        // 定义滚动区
                        const scrollItem = document.getElementById('credits-collapsible');
                        if (scrollItem) {
                            setTimeout(() => {
                                window.scrollTo({
                                    top: scrollItem.offsetTop - 100,
                                    behavior: "smooth"
                                });
                                document.getElementById('credits-collapsible').style.boxShadow = '0 0 20px #999999';
                                document.getElementById('credits-collapsible').style.borderRadius = '12px';
                                setTimeout(() => {
                                    if (document.getElementById('credits-collapsible')) {
                                        document.getElementById('credits-collapsible').style.boxShadow = 'unset';
                                        document.getElementById('credits-collapsible').style.borderRadius = 'unset';
                                    }
                                }, 2000)
                            }, 100)
                        }
                    } else if (_params.query === 'year') {
                        this.move(2)
                    }
                }

                // 判断是否弹窗反馈
                if (showFeedback) {
                    setTimeout(() => {
                        this.setState({
                            isShowFeedback: true
                        })
                    }, 500)
                }

                if (cache) {
                    this.getUserPricingPlanList();
                }
            })
        } else {
            this.props.toggleToast(response.msg, true);
        }
    }

    // 计算年费折扣
    computeAnnualDiscount = (data) => {
        // 计算优惠力度
        let discountText = '';  // 折扣文案
        let o_pre = Number(data[1].price), o_pro = Number(data[0].price);   // 原价 
        let cp_pre = Number(data[1].coupon_info?.discount_price) || o_pre, cp_pro = Number(data[0].coupon_info?.discount_price) || o_pro;   // 优惠券   优惠价格  
        let ap_pre = Number(data[1]?.discount_price) || o_pre, ap_pro = Number(data[0]?.discount_price) || o_pro;                           // 活动     优惠价格  
        let c_pre_trial = Number(data[1].coupon_info?.trial_days) || 0, c_pro_trial = Number(data[0].coupon_info?.trial_days) || 0;
        let c_preRate = Number(data[1].coupon_info?.rate) || -1,
            c_proRate = Number(data[0].coupon_info?.rate) || -1,
            d_preRate = Number(data[1]?.discount_rate) || -1,
            d_proRate = Number(data[0]?.discount_rate) || -1;
        // 存在试用天数 默认
        if (c_pre_trial > 0 || c_pro_trial > 0) {
            if ((c_preRate >= 0 && c_preRate < 1) && (c_proRate >= 0 && c_proRate < 1)) {
                discountText = t("{{v1}} OFF", c_preRate > c_proRate ? `${Number(((1 - c_proRate) * 100).toFixed(0))}%` : `${Number(((1 - c_preRate) * 100).toFixed(0))}%`);
            } else if ((c_preRate >= 0 && c_preRate < 1) && c_proRate >= 1) {
                discountText = (o_pre - cp_pre) > c_proRate ? t("{{v1}} OFF", `${Number(((1 - c_preRate) * 100).toFixed(0))}%`) : `-$${c_proRate}`;
            } else if ((c_proRate >= 0 && c_proRate < 1) && c_preRate >= 1) {
                discountText = (o_pro - cp_pro) > c_preRate ? t("{{v1}} OFF", `${Number(((1 - c_proRate) * 100).toFixed(0))}%`) : `-$${c_preRate}`;
            } else if (c_preRate >= 0 && c_proRate === -1) {
                discountText = c_preRate >= 1 ? `-$${c_preRate}` : t("{{v1}} OFF", `${Number(((1 - c_preRate) * 100).toFixed(0))}%`);
            } else if (c_proRate >= 0 && c_preRate === -1) {
                discountText = c_proRate >= 1 ? `-$${c_proRate}` : t("{{v1}} OFF", `${Number(((1 - c_proRate) * 100).toFixed(0))}%`);
            } else {
                discountText = `-$${c_preRate > c_proRate ? c_preRate : c_proRate}`;
            }
        } else {
            // 不存在试用天数，需要根据 优惠券和活动
            let preRate = 0, proRate = 0;
            let preType = '', proType = 0;
            // 判断 Pre
            if ((c_preRate >= 0 && c_preRate < 1) && (d_preRate >= 0 && d_preRate < 1)) {
                preRate = c_preRate > d_preRate ? Number(((1 - d_preRate)).toFixed(2)) : Number(((1 - c_preRate)).toFixed(2));
                preType = c_preRate > d_preRate ? 'discout' : 'coupon';
            } else if ((c_preRate >= 0 && c_preRate < 1) && d_preRate >= 1) {
                preRate = (o_pre - cp_pre) > d_preRate ? Number(((1 - c_preRate)).toFixed(2)) : d_preRate;
                preType = (o_pre - cp_pre) > d_preRate ? 'coupon' : 'discout';
            } else if ((d_preRate >= 0 && d_preRate < 1) && c_preRate >= 1) {
                preRate = (o_pre - ap_pre) > c_preRate ? Number(((1 - d_preRate)).toFixed(2)) : c_preRate;
                preType = (o_pre - ap_pre) > c_preRate ? 'discout' : 'coupon';
            } else if (c_preRate >= 0 && d_preRate === -1) {
                preRate = c_preRate >= 1 ? c_preRate : Number(((1 - c_preRate)).toFixed(2));
                preType = c_preRate >= 1 ? 'coupon' : 'discout';
            } else if (d_preRate >= 0 && c_preRate === -1) {
                preRate = d_preRate >= 1 ? d_preRate : Number(((1 - d_preRate)).toFixed(2));
                preType = d_preRate >= 1 ? 'discout' : 'coupon';
            } else {
                preRate = c_preRate > d_preRate ? c_preRate : d_preRate;
                preType = c_preRate > d_preRate ? 'coupon' : 'discout';
            }

            // 判断 Pro
            if ((c_proRate >= 0 && c_proRate < 1) && (d_proRate >= 0 && d_proRate < 1)) {
                proRate = c_proRate > d_proRate ? Number(((1 - d_proRate)).toFixed(2)) : Number(((1 - c_proRate)).toFixed(2));
                proType = c_proRate > d_proRate ? 'discout' : 'coupon';
            } else if ((c_proRate >= 0 && c_proRate < 1) && d_proRate >= 1) {
                proRate = (o_pro - cp_pro) > d_proRate ? Number(((1 - c_proRate)).toFixed(2)) : d_proRate;
                proType = (o_pro - cp_pro) > d_proRate ? 'coupon' : 'discout';
            } else if ((d_proRate >= 0 && d_proRate < 1) && c_proRate >= 1) {
                proRate = (o_pro - ap_pro) > c_proRate ? Number(((1 - d_proRate)).toFixed(2)) : c_proRate;
                proType = (o_pro - ap_pro) > c_proRate ? 'discout' : 'coupon';
            } else if (c_proRate >= 0 && d_proRate === -1) {
                proRate = c_proRate >= 1 ? c_proRate : Number(((1 - c_proRate)).toFixed(2));
                proType = c_proRate >= 1 ? 'coupon' : 'discout';
            } else if (d_proRate >= 0 && c_proRate === -1) {
                proRate = d_proRate >= 1 ? d_proRate : Number(((1 - d_proRate)).toFixed(2));
                proType = d_proRate >= 1 ? 'discout' : 'coupon';
            } else {
                proRate = c_proRate > d_proRate ? c_proRate : d_proRate;
                proType = c_proRate > d_proRate ? 'coupon' : 'discout';
            }

            // 比对
            if ((proRate >= 0 && proRate < 1) && (preRate >= 0 && preRate < 1)) {
                discountText = t("{{v1}} OFF", proRate > preRate ? `${(preRate * 100).toFixed(0)}%` : `${(proRate * 100).toFixed(0)}%`);
            } else if ((proRate >= 0 && proRate < 1) && preRate >= 1) {
                let p_origin = proType === 'discount' ? ap_pro : cp_pro;
                discountText = (o_pro - p_origin) > preRate ? t("{{v1}} OFF", `${(proRate * 100).toFixed(0)}%`) : `-$${preRate}`;
            } else if ((preRate >= 0 && preRate < 1) && proRate >= 1) {
                let p_origin = preType === 'discount' ? ap_pre : cp_pre;
                discountText = (o_pre - p_origin) > proRate ? t("{{v1}} OFF", `${(preRate * 100).toFixed(0)}%`) : `-$${proRate}`;
            } else if (proRate >= 0 && preRate === -1) {
                discountText = proRate >= 1 ? `-$${proRate}` : t("{{v1}} OFF", `${(proRate * 100).toFixed(0)}%`);
            } else if (preRate >= 0 && proRate === -1) {
                discountText = preRate >= 1 ? `-$${preRate}` : t("{{v1}} OFF", `${(preRate * 100).toFixed(0)}%`);
            } else {
                discountText = `-$${proRate > preRate ? proRate : preRate}`;
            }
        }

        return discountText.indexOf('-1') > -1 ? t("{{v1}} OFF", "20%") : discountText;
    }

    // 设置按钮宽度
    setTabPlanBtnWidth = () => {
        let mTabBtn = document.getElementById("monthly");
        let yTabBtn = document.getElementById("annual");
        if (mTabBtn && yTabBtn) {
            // Only update if width changes
            const mTabWidth = mTabBtn.clientWidth;
            const yTabWidth = yTabBtn.clientWidth;
            if (mTabWidth !== this.state.mTabBtnWidth || yTabWidth !== this.state.yTabBtnWidth) {
                this.setState({
                    mTabBtnWidth: mTabWidth,
                    yTabBtnWidth: yTabWidth,
                });
            }
        } else {
            requestAnimationFrame(this.setTabPlanBtnWidth);
        }
    }

    verifyGift = (acTime) => {
        let { onlineGiftTiem } = this.state;
        let _store = this.props.public.publicInit;
        let users = _store?.shop_data;
        if (users) {
            if (users.created_at < onlineGiftTiem) {
                // 活动上线前用户
                if (users.level === 1 || (users.level === 3 && acTime >= onlineGiftTiem)) {
                    this.setState({ isShowGiftBlock: true });
                }
            } else {
                this.setState({ isShowGiftBlock: true });
            }
        }
    }

    //升级请求
    updateUserPricingPlan = async (id, discount_id = 0, isMonthModal = 0, level = 0) => {
        this.setState({
            paidLoading: true
        });
        const params = {
            ppid: id,
            discount_id: discount_id,
            is_month_change: isMonthModal,
            checked_level: level
        };
        const response = await reqUpdateUserPricingPlan(params);
        //这里弹窗升降级
        if (response.code === 20001) {
            this.setState({
                modalData: response.data,
                openModalChange: true,
                paidLoading: false,
                //关闭月费降免费弹窗
                openFreePlanDegrade: false,
            });
            return null;
        }
        if (response.code === 200) {
            this.props.toggleToast(response.msg, false);
            //跳转支付页面
            let j_url = response.data.confirmation_url;
            if (j_url) {
                if (window.top) {
                    window.top.location.href = j_url;
                } else {
                    this.handleJumpSubUrl(j_url);
                }
            }
            return null;
        }

        this.setState({
            paidLoading: false,
            openModalChange: false,
            openModalLoading: false,
            //关闭月费降免费弹窗
            openFreePlanDegrade: false,
        });
        this.props.toggleToast(response.msg, true);
        return null;
    }

    //确认转换升级
    updatePlanConversion = async (id, pay_type) => {
        this.setState({
            paidLoading: true,
            openModalLoading: true,
        });
        // 一次性付费
        if (pay_type === 1) {
            const response = await reqPlanConversion({ ppid: id });
            if (response.code === 200) {
                this.setState({
                    paidLoading: false,
                    openModalChange: false,
                });
                this.props.toggleToast(response.msg, false);
                //重新加载数据
                this.getUserPricingPlanList();
            } else {
                this.setState({
                    paidLoading: false,
                    openModalLoading: false
                });
                this.props.toggleToast(response.msg, true);
            }
        }
        // 订阅付费
        if (pay_type === 2) {
            this.updateUserPricingPlan(id, 0, 1);
        }

        return null;
    }

    // 时分秒倒计时
    countdown = async (end_time) => {
        let cacheTimer = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            if (date3 < 1000) {
                clearInterval(cacheTimer);
            } else {
                //计算出小时数
                let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";

                if (hours < 10) {
                    exp_time += "0" + hours + ":";
                } else {
                    exp_time += hours + ":";
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":";
                } else {
                    exp_time += minutes + ":";
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds;
                } else if (seconds === 60) {
                    exp_time += "00";
                } else {
                    exp_time += seconds;
                }

                this.setState({
                    expired_time: exp_time,
                })
            }
        }, 1000)
        // 毫秒倒计时
        setTimeout(() => {
            setInterval(() => {
                let date1 = new Date(); //开始时间
                let date2 = end_time * 1000; //开始时间
                let date3 = date2 - date1 //时间差的毫秒数
                if (date3 < 0) {
                    this.setState({ milli_second: "00" })
                } else {
                    //计算相差毫秒数
                    let milli = date3 % (100)

                    let exp_time = "";

                    if (milli < 10) {
                        exp_time += "0" + milli
                    } else {
                        exp_time += milli
                    }
                    this.setState({ milli_second: exp_time })
                }
            }, 80)
        }, 1000)
    }

    // 时分秒倒计时
    actCountdown = async (end_time, field = '', type = '') => {
        let cacheTimer = setInterval(() => {
            let date1 = new Date(); //开始时间
            let date2 = end_time * 1000; //开始时间
            let date3 = date2 - date1 //时间差的毫秒数
            if (date3 < 1000) {
                clearInterval(cacheTimer);
                this.setState({
                    [field]: 0,
                    preDiscountPrice: -1,
                    proDiscountPrice: -1,
                    diyBannerState: false,
                }, () => {
                    this.getUserPricingPlanList();
                })
            } else {
                //计算出小时数
                let leave1 = date3 % (24 * 3600 * 1000)  //计算天数后剩余的毫秒数
                let hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                let leave2 = leave1 % (3600 * 1000)    //计算小时数后剩余的毫秒数
                let minutes = Math.floor(leave2 / (60 * 1000))
                //计算相差秒数
                let leave3 = leave2 % (60 * 1000)   //计算分钟数后剩余的毫秒数
                let seconds = Math.round(leave3 / 1000)

                let exp_time = "";
                let cdays = '', chours = '', cmins = '', csecs = '';

                if (hours < 10) {
                    exp_time += "0" + hours + ":";
                    cdays = `00`;
                    chours = `0${hours}`;
                } else {
                    exp_time += hours + ":";
                    cdays = `${Math.floor(hours / 24) < 10 ? '0' + Math.floor(hours / 24) : Math.floor(hours / 24)}`;
                    chours = `${(hours % 24) < 10 ? '0' + (hours % 24) : hours % 24}`;
                }
                if (minutes < 10) {
                    exp_time += "0" + minutes + ":";
                    cmins = `0${minutes}`;
                } else {
                    exp_time += minutes + ":";
                    cmins = `${minutes}`;
                }
                if (seconds < 10) {
                    exp_time += "0" + seconds;
                    csecs = `0${seconds}`;
                } else if (seconds === 60) {
                    exp_time += "00";
                    csecs = `00`;
                } else {
                    exp_time += seconds;
                    csecs = `${seconds}`;
                }
                let { diyBannerState } = this.state;
                this.setState({
                    [field]: exp_time,
                    diyBannerState: diyBannerState === -1 ? true : diyBannerState,
                    cDays: cdays,
                    cHours: chours,
                    cMins: cmins,
                    cSecs: csecs,
                })
            }
        }, 1000)
        if (Boolean(type)) {
            // 月费
            if (type === 'premDis') {
                premArr.push(cacheTimer)
            }
            if (type === 'promDis') {
                promArr.push(cacheTimer)
            }
            if (type === 'premCode') {
                premArr.push(cacheTimer)
            }
            if (type === 'promCode') {
                promArr.push(cacheTimer)
            }
            // 年费
            if (type === 'preyDis') {
                preyArr.push(cacheTimer)
            }
            if (type === 'proyDis') {
                proyArr.push(cacheTimer)
            }
            if (type === 'preyCode') {
                preyArr.push(cacheTimer)
            }
            if (type === 'proyCode') {
                proyArr.push(cacheTimer)
            }
        }
        // 毫秒倒计时
        setTimeout(() => {
            setInterval(() => {
                let date1 = new Date(); //开始时间
                let date2 = end_time * 1000; //开始时间
                let date3 = date2 - date1 //时间差的毫秒数
                if (date3 < 0) {
                    this.setState({
                        [`${field}_mills`]: '00'
                    })
                } else {
                    //计算相差毫秒数
                    let milli = date3 % (100)

                    let exp_time = "";

                    if (milli < 10) {
                        exp_time += "0" + milli
                    } else {
                        exp_time += milli
                    }
                    this.setState({ [`${field}_mills`]: exp_time })
                }
            }, 80)
        }, 1000)
    }

    // 移动动画
    move = (val) => {
        let type = ['month', 'year'];
        const pricing = this.state.pricingData;
        let plans = pricing.meal_list;
        let monthProPrice = plans['month'][0].price;
        let monthPrePrice = plans['month'][1].price;
        let proPlanPrice = plans[type[val - 1]][0].price;
        let prePlanPrice = plans[type[val - 1]][1].price;
        let freePlanPrice = plans['free'][0].price;
        // 切换tab 需要根据当前版本判断按钮状态
        this.setState({
            freePlanBtnStatus: pricing.level !== 1 ? 1 : 0,
            isMonthOrYear: val
        })
        if (val === 1) {
            // 月
            // 判断优惠力度 计算使用哪个折扣周期
            let prodisType = '', predisType = '';
            let proPeriod = 0, prePeriod = 0;
            let mPro = plans['month'][0], mPre = plans['month'][1];
            let isShowCouponDis = this.state.isShowCouponDis; // 活动
            let mProTrialDays = mPro.coupon_info?.trial_days || 0;
            let mPreTrialDays = mPre.coupon_info?.trial_days || 0;
            let newUserinfo = cloneDeep(this.state.userInfo);
            // pro plan
            if (Boolean(mPro?.discount_period >= 0) && Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(mPro['coupon_info']['rate'])) && Number(mPro['coupon_info']['rate']) < 0 && mProTrialDays === 0) {
                    if (Number(mPro['discount_price']) >= 0) {
                        proPeriod = mPro.discount_period;
                        prodisType = 'discount';
                    }
                } else if (Number(mPro['coupon_info']['rate']) >= 0 && Number(mPro['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(mPro['coupon_info']['rate'])) * monthProPrice).toFixed(2)) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0) && mProTrialDays === 0) {
                        // if(mPro.discount_period < mPro.coupon_info.discount_period) {
                        //     proPeriod = mPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = mPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = mPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(mPro['coupon_info']['rate']) >= 1) {
                    if (Number(monthProPrice - Number(mPro['coupon_info']['rate'])) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0) && mProTrialDays === 0) {
                        // if(mPro.discount_period < mPro.coupon_info.discount_period) {
                        //     proPeriod = mPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = mPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = mPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    proPeriod = 0;
                    prodisType = '';
                }
            } else {
                if (Boolean(mPro?.discount_period >= 0)) {
                    proPeriod = mPro.discount_period;
                    prodisType = 'discount';
                }
                if (Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                    proPeriod = mPro.coupon_info.discount_period;
                    prodisType = 'code';
                    isShowCouponDis = true;
                }
            }
            // pre plan
            if (Boolean(mPre?.discount_period >= 0) && Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(mPre['coupon_info']['rate'])) && Number(mPre['coupon_info']['rate']) < 0 && mPreTrialDays === 0) {
                    if (Number(mPre['discount_price']) >= 0) {
                        prePeriod = mPre.discount_period;
                        predisType = 'discount';
                    }
                } else if (Number(mPre['coupon_info']['rate']) >= 0 && Number(mPre['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(mPre['coupon_info']['rate'])) * monthPrePrice).toFixed(2)) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0) && mPreTrialDays === 0) {
                        // if (mPre.discount_period < mPre.coupon_info.discount_period) {
                        //     prePeriod = mPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = mPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = mPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(mPre['coupon_info']['rate']) >= 1) {
                    if (Number(monthPrePrice - Number(mPre['coupon_info']['rate'])) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0) && mPreTrialDays === 0) {
                        // if (mPre.discount_period < mPre.coupon_info.discount_period) {
                        //     prePeriod = mPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = mPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = mPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    prePeriod = 0;
                    predisType = '';
                }
            } else {
                if (Boolean(mPre?.discount_period >= 0)) {
                    prePeriod = mPre.discount_period;
                    predisType = 'discount';
                }
                if (Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                    prePeriod = mPre.coupon_info.discount_period;
                    predisType = 'code';
                    isShowCouponDis = true;
                }
            }
            newUserinfo.pro_trial_days = mProTrialDays;
            newUserinfo.pre_trial_days = mPreTrialDays;
            this.setState({
                moveAnimation: 1,
                prePlanPrice,
                proPlanPrice,
                prePlanDiscountPrice: 0,
                proPlanDiscountPrice: 0,
                freePlanPrice,
                prePlanId: 4,
                proPlanId: 2,
                preDiscount: Number(plans['month'][1]?.coupon_info?.rate) === 0 ? '' : Number(plans['month'][1]?.coupon_info?.rate),
                proDiscount: Number(plans['month'][0]?.coupon_info?.rate) === 0 ? '' : Number(plans['month'][0]?.coupon_info?.rate),
                isShowMonth: true,
                isShowYear: false,
                preVersionLevel: '1_pre',
                proVersionLevel: '1_pro',
                preDiscountPrice: (plans['month'][1].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['month'][1].discount_price) ? (Number(plans['month'][1].discount_price) === 0 ? 0 : Number(plans['month'][1].discount_price)) : -1) : -1,
                proDiscountPrice: (plans['month'][0].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['month'][0].discount_price) ? (Number(plans['month'][0].discount_price) === 0 ? 0 : Number(plans['month'][0].discount_price)) : -1) : -1,
                preMonthPeriod: Boolean(prePeriod) ? Number(prePeriod) : 0,
                proMonthPeriod: Boolean(proPeriod) ? Number(proPeriod) : 0,
                isShowCouponDis,
                userInfo: newUserinfo,
            }, () => {
                // 当不是免费用户 且 套餐等级不是月费时 
                // 当用户是月费不走
                let isHasTrialmPre = pricing.trial_days !== 0 ? true : newUserinfo?.pre_trial_days ? true : false;  // Pre
                let isHasTrialmPro = pricing.trial_days !== 0 ? true : newUserinfo?.pro_trial_days ? true : false;  // Pro

                switch (Number(pricing.level)) {
                    case 1:
                        if (Number(pricing.ppid) === 1) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 2:
                        if (Number(pricing.ppid) === 2) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: 0,
                                expertPlanBtnStatus: 2,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 3:
                        if (Number(pricing.ppid) === 4) {
                            this.setState({
                                prePlanBtnStatus: 0,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        } else if (Number(pricing.ppid) === 10) {
                            this.setState({
                                prePlanBtnStatus: 2,
                                proPlanBtnStatus: 2,
                                expertPlanBtnStatus: 0,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialmPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialmPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    default:
                        return;
                }
                // 计算倒计时  discount_period
                if (Boolean(plans['month'][1].discount_exp) && predisType === 'discount') {
                    if (premArr.length > 0) {
                        this.delTimeArrPreData();
                    }
                    let timePoint = plans['month'][1].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(timePoint, 'preMonthCountDown', 'premDis')
                        }, 0)
                    }
                }
                if (Boolean(plans['month'][0].discount_exp) && prodisType === 'discount') {
                    if (premArr.length > 0) {
                        this.delTimeArrProData();
                    }
                    let timePoint = plans['month'][0].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(plans['month'][0].discount_exp, 'proMonthCountDown', 'promDis')
                        }, 0)
                    }
                }
                if (Boolean(plans['month'][1]?.coupon_info?.expires_in) && predisType === 'code') {
                    this.setState({
                        preMRecode: plans['month'][1].coupon_info.code
                    }, () => {
                        if (premArr.length > 0) {
                            this.delTimeArrPreData();
                        }
                        let timePoint = plans['month'][1].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['month'][1].coupon_info.expires_in, 'preMonthCountDown', 'premCode')
                            }, 0)
                        }
                    })
                }
                if (Boolean(plans['month'][0]?.coupon_info?.expires_in) && prodisType === 'code') {
                    this.setState({
                        proMRecode: plans['month'][0].coupon_info.code
                    }, () => {
                        if (promArr.length > 0) {
                            this.delTimeArrProData();
                        }
                        let timePoint = plans['month'][0].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['month'][0].coupon_info.expires_in, 'proMonthCountDown', 'promCode')
                            }, 0)
                        }
                    })
                }
            })
        } else if (val === 2) {
            // 年
            // 判断优惠力度 计算使用哪个折扣周期
            let prodisType = '', predisType = '';
            let proPeriod = 0, prePeriod = 0;
            let yPro = plans['year'][0], yPre = plans['year'][1];
            let isShowCouponDis = this.state.isShowCouponDis; // 活动
            let yProTrialDays = yPro.coupon_info?.trial_days || 0;
            let yPreTrialDays = yPre.coupon_info?.trial_days || 0;
            let newUserinfo = cloneDeep(this.state.userInfo);
            // pro plan
            if (Boolean(yPro?.discount_period >= 0) && Boolean(yPro?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(yPro['coupon_info']['rate'])) && Number(yPro['coupon_info']['rate']) < 0 && yProTrialDays === 0) {
                    if (Number(yPro['discount_price']) >= 0) {
                        proPeriod = yPro.discount_period;
                        prodisType = 'discount';
                    }
                } else if (Number(yPro['coupon_info']['rate']) >= 0 && Number(yPro['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(yPro['coupon_info']['rate'])) * monthProPrice).toFixed(2)) >= Number(yPro['discount_price']) && Boolean(yPro['discount_price'] >= 0) && yProTrialDays === 0) {
                        // if(yPro.discount_period < yPro.coupon_info.discount_period) {
                        //     proPeriod = yPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = yPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = yPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(yPro['coupon_info']['rate']) >= 1) {
                    if (Number(monthProPrice - Number(yPro['coupon_info']['rate'])) >= Number(yPro['discount_price']) && Boolean(yPro['discount_price'] >= 0) && yProTrialDays === 0) {
                        // if(yPro.discount_period < yPro.coupon_info.discount_period) {
                        //     proPeriod = yPro.coupon_info.discount_period;
                        //     prodisType = 'code';
                        // } else {
                        proPeriod = yPro.discount_period;
                        prodisType = 'discount';
                        // }
                    } else {
                        proPeriod = yPro.coupon_info.discount_period;
                        prodisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    proPeriod = 0;
                    prodisType = '';
                }
            } else {
                if (Boolean(yPro?.discount_period >= 0)) {
                    proPeriod = yPro.discount_period;
                    prodisType = 'discount';
                }
                if (Boolean(yPro?.coupon_info?.discount_period >= 0)) {
                    proPeriod = yPro.coupon_info.discount_period;
                    prodisType = 'code';
                    isShowCouponDis = true;
                }
            }
            // pre plan
            if (Boolean(yPre?.discount_period >= 0) && Boolean(yPre?.coupon_info?.discount_period >= 0)) {
                if (!Boolean(Number(yPre['coupon_info']['rate'])) && Number(yPre['coupon_info']['rate']) < 0 && yPreTrialDays === 0) {
                    if (Number(yPre['discount_price']) >= 0) {
                        prePeriod = yPre.discount_period;
                        predisType = 'discount';
                    }
                } else if (Number(yPre['coupon_info']['rate']) >= 0 && Number(yPre['coupon_info']['rate']) < 1) {
                    if (Number((Number(Number(yPre['coupon_info']['rate'])) * monthPrePrice).toFixed(2)) >= Number(yPre['discount_price']) && Boolean(yPre['discount_price'] >= 0) && yPreTrialDays === 0) {
                        // if(yPre.discount_period < yPre.coupon_info.discount_period) {
                        //     prePeriod = yPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = yPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = yPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else if (Number(yPre['coupon_info']['rate']) >= 1) {
                    if (Number(monthPrePrice - Number(yPre['coupon_info']['rate'])) >= Number(yPre['discount_price']) && Boolean(yPre['discount_price'] >= 0) && yPreTrialDays === 0) {
                        // if(yPre.discount_period < yPre.coupon_info.discount_period) {
                        //     prePeriod = yPre.coupon_info.discount_period;
                        //     predisType = 'code';
                        // } else {
                        prePeriod = yPre.discount_period;
                        predisType = 'discount';
                        // }
                    } else {
                        prePeriod = yPre.coupon_info.discount_period;
                        predisType = 'code';
                        isShowCouponDis = true;
                    }
                } else {
                    prePeriod = 0;
                    predisType = '';
                }
            } else {
                if (Boolean(yPre?.discount_period >= 0)) {
                    prePeriod = yPre.discount_period;
                    predisType = 'discount';
                }
                if (Boolean(yPre?.coupon_info?.discount_period >= 0)) {
                    prePeriod = yPre.coupon_info.discount_period;
                    predisType = 'code';
                    isShowCouponDis = true;
                }
            }
            newUserinfo.pro_trial_days = yProTrialDays;
            newUserinfo.pre_trial_days = yPreTrialDays;
            this.setState({
                moveAnimation: 2,
                prePlanPrice,
                proPlanPrice,
                proPlanDiscountPrice: (monthProPrice * 12).toFixed(2),
                prePlanDiscountPrice: (monthPrePrice * 12).toFixed(2),
                freePlanPrice,
                prePlanId: 9,
                proPlanId: 8,
                preDiscount: Number(plans['year'][1]?.coupon_info?.rate) === 0 ? 0 : Number(plans['year'][1]?.coupon_info?.rate),
                proDiscount: Number(plans['year'][0]?.coupon_info?.rate) === 0 ? 0 : Number(plans['year'][0]?.coupon_info?.rate),
                isShowMonth: false,
                isShowYear: true,
                preVersionLevel: '2_pre',
                proVersionLevel: '2_pro',
                preDiscountPrice: (plans['year'][1].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['year'][1].discount_price) ? (Number(plans['year'][1].discount_price) === 0 ? 0 : Number(plans['year'][1].discount_price)) : -1) : -1,
                proDiscountPrice: (plans['year'][0].discount_exp > new Date().getTime() / 1000) ? (Boolean(plans['year'][0].discount_price) ? (Number(plans['year'][0].discount_price) === 0 ? 0 : Number(plans['year'][0].discount_price)) : -1) : -1,
                preYearPeriod: Boolean(prePeriod) ? Number(prePeriod) : 0,
                proYearPeriod: Boolean(proPeriod) ? Number(proPeriod) : 0,
                // preYearPeriod: Boolean(plans['year'][1].discount_period && plans['year'][1].discount_period !== 0) ? Number(plans['year'][1].discount_period) : 0,
                // proYearPeriod: Boolean(plans['year'][0].discount_period && plans['year'][0].discount_period !== 0) ? Number(plans['year'][0].discount_period) : 0,
                isShowCouponDis,
                userInfo: newUserinfo,
            }, () => {
                // 当不是免费用户 且 套餐等级不是月费时 
                // 当用户是月费不走
                let isHasTrialyPre = pricing.trial_days !== 0 ? true : newUserinfo?.pre_trial_days ? true : false;  // Prem..
                let isHasTrialyPro = pricing.trial_days !== 0 ? true : newUserinfo?.pro_trial_days ? true : false;  // Pro
                switch (Number(pricing.level)) {
                    case 1:
                        if (Number(pricing.ppid) === 1) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 2:
                        if (Number(pricing.ppid) === 8) {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: 0,
                                expertPlanBtnStatus: 2,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    case 3:
                        if (Number(pricing.ppid) === 9) {
                            this.setState({
                                prePlanBtnStatus: 0,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        } else if (Number(pricing.ppid) === 10) {
                            this.setState({
                                prePlanBtnStatus: 2,
                                proPlanBtnStatus: 2,
                                expertPlanBtnStatus: 0,
                            })
                        } else {
                            this.setState({
                                prePlanBtnStatus: isHasTrialyPre ? 3 : 2,
                                proPlanBtnStatus: isHasTrialyPro ? 3 : 2,
                                expertPlanBtnStatus: 2,
                            })
                        }
                        break;
                    default:
                        return;
                }
                // 计算倒计时
                if (Boolean(plans['year'][1].discount_exp) && predisType === 'discount') {
                    if (preyArr.length > 0) {
                        this.delTimeArrPreYData();
                    }
                    let timePoint = plans['year'][1].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(plans['year'][1].discount_exp, 'preYearCountDown', 'preyDis')
                        }, 0)
                    }
                }
                if (Boolean(plans['year'][0].discount_exp) && prodisType === 'discount') {
                    if (proyArr.length > 0) {
                        this.delTimeArrProYData();
                    }
                    let timePoint = plans['year'][0].discount_exp;
                    if (timePoint < 4070880000) {
                        setTimeout(() => {
                            this.actCountdown(plans['year'][0].discount_exp, 'proYearCountDown', 'proyDis')
                        }, 0)
                    }
                }

                if (Boolean(plans['year'][1]?.coupon_info?.expires_in) && predisType === 'code') {
                    this.setState({
                        preYRecode: plans['year'][1].coupon_info.code
                    }, () => {
                        if (preyArr.length > 0) {
                            this.delTimeArrPreYData();
                        }
                        let timePoint = plans['year'][1].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['year'][1].coupon_info.expires_in, 'preYearCountDown', 'preyCode')
                            }, 0)
                        }
                    })
                }
                if (Boolean(plans['year'][0]?.coupon_info?.expires_in) && prodisType === 'code') {
                    this.setState({
                        proYRecode: plans['year'][0].coupon_info.code
                    }, () => {
                        if (proyArr.length > 0) {
                            this.delTimeArrProYData();
                        }
                        let timePoint = plans['year'][0].coupon_info.expires_in;
                        if (timePoint < 4070880000) {
                            setTimeout(() => {
                                this.actCountdown(plans['year'][0].coupon_info.expires_in, 'proYearCountDown', 'proyCode')
                            }, 0)
                        }
                    })
                }
            })
        } else { }
    }

    // 删除Pre订阅器
    delTimeArrPreData = () => {
        premArr.map(timer => {
            clearInterval(timer);
            premArr.pop();
            return false;
        })
    }
    // 删除Pro订阅器
    delTimeArrProData = () => {
        promArr.map(timer => {
            clearInterval(timer);
            promArr.pop();
            return false;
        })
    }
    // 删除Pre订阅器
    delTimeArrPreYData = () => {
        preyArr.map(timer => {
            clearInterval(timer);
            preyArr.pop();
            return false;
        })
    }
    // 删除Pro订阅器
    delTimeArrProYData = () => {
        proyArr.map(timer => {
            clearInterval(timer);
            proyArr.pop();
            return false;
        })
    }

    // 价格详情展开方法
    setExpanded = (val) => {
        this.setState({
            pricingDetailBtnStatus: val,
            isShowPricingState: !this.state.isShowPricingState
        })
    }

    // 升级/切换套餐
    handleUpdatePricingMeal = async (id, price, ver_level, disObject) => {
        let { isComboUser, defalutDis } = this.state;
        if (isComboUser) {
            // cw组合付费用户
            this.setState({
                isShowCwComboModal: true
            }, () => {
                let yPrice = !Boolean(disObject?.discount) ? ((price * defalutDis) / 12).toFixed(2) : (price / 12).toFixed(2);
                this.cioDataSet(([2, 4].includes(id) ? 'monthly' : [8, 9].includes(id) ? 'annually' : ''), ([2, 8].includes(id) ? 'Pro Plan' : [4, 9].includes(id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(id) ? yPrice : price));
            })
        } else {
            // 计算最后的提交价格
            let endPrice = 0;
            let isGetDiscount = false;
            let isGetCodeDiscount = false;
            // 判断优惠力度
            if (!Boolean(disObject.discount) && (Number(disObject.discount) < 0 || isNaN(disObject.discount))) {
                // 优惠折扣
                if (disObject.actMealDiscount > 0) {
                    endPrice = disObject.actMealDiscount;
                    isGetDiscount = true;
                } else {
                    endPrice = price;
                }
            } else if (Number(disObject.discount) >= 0 && Number(disObject.discount) < 1) {
                if (Number((Number(Number(disObject.discount)) * price).toFixed(2)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                    endPrice = disObject.actMealDiscount;
                    isGetDiscount = true;
                } else {
                    endPrice = Number((Number(Number(disObject.discount)) * price).toFixed(2));
                    isGetCodeDiscount = true;
                    // endPrice = price;
                }
            } else if (Number(disObject.discount) >= 1) {
                if (Number(price - Number(disObject.discount)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                    endPrice = disObject.actMealDiscount;
                    isGetDiscount = true;
                } else {
                    endPrice = Number(price - Number(disObject.discount));
                    isGetCodeDiscount = true;
                    // endPrice = price;
                }
            } else {
                endPrice = price;
            }
            this.setState({
                paidLoading: true,
                paidDisabled: true,
                paidBtnLoading: ver_level
            })
            let params = {
                ppid: id,
                price: Number(endPrice),
                is_verify: 0,
            }
            if (isGetDiscount) {
                // 活动折扣
                let ppList = this.state.pricingPlanList;
                let list_plan = [...ppList['free'], ...ppList['month'], ...ppList['year']];
                params['activity_id'] = list_plan.filter(item => item.id === id)[0].activity_id;
            }
            if (isGetCodeDiscount) {
                // 优惠券折扣
                let { proMRecode, preMRecode, proYRecode, preYRecode } = this.state;
                params['coupon_code'] = id === 2 ? proMRecode : id === 4 ? preMRecode : id === 8 ? proYRecode : id === 9 ? preYRecode : proMRecode;
            }
            // cio埋点
            let yPrice = !Boolean(disObject?.discount) ? ((endPrice * defalutDis) / 12).toFixed(2) : (endPrice / 12).toFixed(2);
            this.cioDataSet(([2, 4].includes(id) ? 'monthly' : [8, 9].includes(id) ? 'annually' : ''), ([2, 8].includes(id) ? 'Pro Plan' : [4, 9].includes(id) ? 'Pre Plan' : ''), 0, ([8, 9].includes(id) ? yPrice : endPrice));
            // 请求
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                // this.props.toggleToast(res.msg, false);
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        this.handleJumpSubUrl(j_url);
                    }
                }
            } else {
                // 老用户一次性付费
                if (res.code === 202) {
                    this.setState({
                        oldPayModalStatus: true,
                        paidLoading: false
                    })
                } else {
                    this.setState({
                        paidLoading: false,
                        paidBtnLoading: '',
                        paidDisabled: false,
                    }, () => {
                        this.props.toggleToast(res.msg, true);
                    })
                }
            }
        }
    }

    // 增加服务升级
    handleUpdatePricingMealExpert = () => {
        // this.cioDataSet('monthly', 'Enterprise', 0, 399);
        this.setState({
            paidLoading: true,
            paidDisabled: true,
            paidBtnLoading: 10,
        }, async () => {
            let params = {
                ppid: 10,
            }
            const res = await reqGetSubscription(params);
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        this.handleJumpSubUrl(j_url);
                    }
                }
            } else {
                // 老用户一次性付费
                if (res.code === 202) {
                    this.setState({
                        oldPayModalStatus: true,
                        paidLoading: false
                    })
                } else {
                    this.setState({
                        paidLoading: false,
                        paidDisabled: false,
                        paidBtnLoading: '',
                    }, () => {
                        this.props.toggleToast(res.msg, true);
                    })
                }
            }
        })
    }

    // 降级免费
    handleDowngrade = (isTrue = false, isSkip = false) => {
        let { isHaveDiscount, isComboUser } = this.state;
        if (isComboUser) {
            // cw组合付费用户
            this.setState({
                isShowCwComboModal: true
            })
        } else {
            if (!isTrue) {
                // 弹窗确认是否降级
                this.setState({
                    openFreePlanDegrade: true,
                })
            } else if (isHaveDiscount && !isSkip) {
                // 降级优惠折扣
                this.setState({
                    openFreePlanDegrade: false,
                    isShowFiveModal: true
                })
            } else {
                this.setState({
                    paidLoading: true
                }, async () => {
                    // 确认降级
                    const res = await reqGetSubscriptionCancel({ ppid: this.state.userInfo.ppid });
                    if (res.ack === 1) {
                        this.props.toggleToast(res.msg, false)
                        setTimeout(() => {
                            this.setState({
                                openFreePlanDegrade: false,
                                isShowFiveModal: false,
                                paidLoading: false,
                                loadingPage: true,
                            }, () => {
                                // 获取套餐版本
                                this.getPublicData();
                                this.getUserPricingPlanList(isSkip);
                            })
                        }, 1000)
                    } else {
                        this.setState({
                            paidLoading: false
                        }, () => {
                            this.props.toggleToast(res.msg, true)
                        })
                    }
                })
            }
        }
    }

    // 积分面板状态
    showCreditsBox = () => {
        this.setState({
            upShowCredits: !this.state.upShowCredits
        })
    }

    // 关闭就用户再支付提示弹窗
    closePayTipModal = () => {
        this.setState({
            oldPayModalStatus: !this.state.oldPayModalStatus,
            paidDisabled: false,
            paidBtnLoading: '',
        })
    }

    // 购买积分
    purchaseMeal = (val) => {
        this.setState({
            curPurId: val,
            purBtnStatus: true
        }, async () => {
            const res = await reqAppApplicationCharge({ meal_id: Number(val) });
            if (res.ack === 1) {
                this.props.toggleToast(res.msg, false);
                //跳转支付页面
                let j_url = res.data.jump_url;
                if (j_url) {
                    if (window.top) {
                        window.top.location.href = j_url;
                    } else {
                        this.handleJumpSubUrl(j_url);
                    }
                }
            } else {
                this.props.toggleToast(res.msg, true);
                this.setState({
                    curPurId: -1,
                    purBtnStatus: false
                })
            }
        })
    }

    // 监听支付跳转
    handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                this.handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 输入折扣码
    handleDiscountChange = (val) => {
        this.setState({
            discountVal: val,
            discountValError: ''
        })
    }

    // 验证折扣码
    verifyDisCode = async () => {
        let { discountVal } = this.state;
        if (!Boolean(discountVal)) {
            this.setState({
                discountValError: 'The input field cannot be empty'
            })
            return false;
        }
        this.setState({ disBtnLoading: true })
        const params = {
            ref_code: discountVal.trim()
        }
        const res = await reqGetPricingCouponData(params);
        if (res.ack === 1) {
            const planList = {
                0: "All plan",
                2: "Pro plan",
                4: "Pre plan",
                8: "Pro plan year", // 已隐藏的版本
                9: "Pre plan year", // 已隐藏的版本
            }
            let rate = Number(res.data.rate);
            this.setState({
                discountRate: rate === 0 ? 0 : (rate < 1 ? (1 - rate) : rate),
                discountPlan: Boolean(planList[res.data.meal_plan]) ? planList[res.data.meal_plan] : "All plan",
                isShowDisTicket: true,
                discountValError: '',
            }, () => {
                this.getUserPricingPlanList();
            })
        } else {
            this.setState({
                discountValError: res.msg
            })
        }

        if (res) {
            this.setState({
                disBtnLoading: false,
            })
        }

    }

    // 打开额外福利弹窗
    showExtraGiftModal = () => {
        this.setState({
            isShowExtraGift: true
        })
    }

    // 关闭倒计时banner
    closeTimeBanner = () => {
        this.setState({
            diyBannerState: false,
        }, () => {
            this.requestStateSet('pricingTimeBanner');
        })
    }

    // 打开反馈弹窗
    openFeedbackModal = (showFeedback = false) => {
        this.setState({
            isShowFiveModal: false,
            isShowFeedback: showFeedback,
        })
    }

    // 发送反馈
    sendFeedbackInfo = () => {
        let { updateFeedback, notExpectVal, poorVal, lackVal, performVal, securityVal, expensiveVal, softwareVal, othersVal, notExpectInfoVal, poorInfoVal, lackInfoVal, performInfoVal, securityInfoVal, expensiveInfoVal, softwareInfoVal, othersInfoVal } = this.state;
        let dataObj = {
            notExpect: { state: notExpectVal, value: notExpectInfoVal, field: 'Function not as expected' },
            poor: { state: poorVal, value: poorInfoVal, field: 'Poor user interface experience' },
            lack: { state: lackVal, value: lackInfoVal, field: 'Lack of required features or content' },
            perform: { state: performVal, value: performInfoVal, field: 'Performance issues (such as lags, crashes, etc.)' },
            security: { state: securityVal, value: securityInfoVal, field: 'security concerns' },
            expensive: { state: expensiveVal, value: expensiveInfoVal, field: 'Too expensive' },
            software: { state: softwareVal, value: softwareInfoVal, field: 'There is more suitable software to use' },
            others: { state: othersVal, value: othersInfoVal, field: 'Others' },
            update: { state: true, value: updateFeedback, field: 'update' },
        }
        let reasonField = Object.keys(dataObj).filter(r => r !== 'update' && r !== 'others' && dataObj[r].state);
        let otherState = dataObj.others.state && dataObj.others.value.replace(/\s/g, "") === "";
        let updateState = dataObj.update.state && dataObj.update.value.replace(/\s/g, "") === "";
        this.setState({
            sendLoading: true,
        }, async () => {
            if ((reasonField.length > 0 || (!otherState && dataObj.others.state)) && !updateState) {
                const params = {
                    flag: 3,
                    title: "SEOAnt-降级反馈",
                    description: JSON.stringify(dataObj)
                }
                const res = await reqReviewTipsClick(params);
                if (res.ack === 1) {
                    this.props.toggleToast(t("Success"));
                    this.setState({
                        sendLoading: false,
                        isShowFeedback: false,
                    }, () => {
                        this.closeNeedFeedback();
                        setTimeout(() => {
                            this.setState({
                                discountVal: 'SEOAnt50',
                                codeFocus: true
                            })
                        }, 500)
                    })
                } else {
                    this.setState({
                        sendLoading: false,
                        isShowWarnFeedback: res.msg,
                    })
                }
            } else {
                this.setState({
                    isShowReasonSet: (reasonField.length === 0 && (otherState || !dataObj.others.state)) ? true : this.state.isShowReasonSet,
                    isShowUpdateSet: updateState ? true : this.state.isShowUpdateSet,
                    sendLoading: false,
                    isShowWarnFeedback: "The selected options must be filled in",
                })
            }
        })
    }

    // 下拉反馈填写
    openFeedbackSet = (type = 1) => {
        let { isShowReasonSet, isShowUpdateSet } = this.state;
        if (type === 1) {
            this.setState({
                isShowReasonSet: !isShowReasonSet
            })
        } else {
            this.setState({
                isShowUpdateSet: !isShowUpdateSet
            })
        }
    }

    // 输入
    handleInputVal = (val, type) => {
        this.setState({
            [type]: val
        })
    }

    // 多选
    handleCheckVal = (val, type) => {
        this.setState({
            [type]: val
        })
    }

    // 关闭反馈
    closeNeedFeedback = () => {
        this.setState({
            isShowFeedback: false,
            isShowReasonSet: false,
            isShowUpdateSet: false,
            notExpectVal: false,
            poorVal: false,
            lackVal: false,
            performVal: false,
            securityVal: false,
            expensiveVal: false,
            softwareVal: false,
            othersVal: false,
            notExpectInfoVal: '',
            poorInfoVal: '',
            lackInfoVal: '',
            performInfoVal: '',
            securityInfoVal: '',
            expensiveInfoVal: '',
            softwareInfoVal: '',
            othersInfoVal: '',
            updateFeedback: '',
            isShowWarnFeedback: '',
        })
    }

    // 更新公共数据
    getPublicData = async () => {
        const params = new URLSearchParams(window.location.search);
        if (getCookie("seoant_irclickid") && getCookie("seoant_irclickid").length > 1) {
            params.set('irclickid', getCookie("seoant_irclickid"));
        }
        const response = await reqGetHomeCommonData(params); // 新公共接口
        if (response.code === 301) {
            window.location.href = response.jump_url;
        } else {
            if (response.code === 200) {
                this.props.getPublicDataRedux(response);
            }

        }
    }

    // 轮播图滚动监听
    onSlideChangeInx = (e) => {
        this.setState({
            swiperInx: e.realIndex + 1
        })
    }

    // 切换轮播图
    handlSliedChange = (e) => {
        this.setState({
            swiperInx: e
        }, () => {
            if (this.swiperRef.current && this.swiperRef.current.swiper) {
                this.swiperRef.current.swiper.slideTo(e - 1); // Swiper 的索引从 0 开始，所以减去 1
            }
        })
    }

    // 选择版本
    continueAsFree = () => {
        this.setState({
            asFreeLoading: true,
        }, async () => {
            this.requestStateSet("select_version", 1);
        })
    }

    // 跳转cw集合页
    goSolutionExpert = () => {
        utils.routeJump(this, "/settings", null, { selected: "Solutionexpert", tabkey: 4 });
    }

    // 调起客服
    handleContactService = (content = "") => {
        try {
            showNewMessage(content);
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 跳转页面
    jumpUrl = (url) => {
        utils.routeJump(this, url);
    }

    // 打开预约
    openBookDemo = () => {
        window.open("https://calendly.com/bruceli202108/30min");
    }

    // 年月费切换
    handlePlansToggle = (type) => {
        this.move(type)
    };

    // cw埋点
    cioDataSet = (type, version, quota, price) => {
        try {
            if (window.shopify && window.cio?.initialized) {
                window.cio?.trigger({
                    event: 'change_plan',
                    payload: {
                        plan_type: type, // 'monthly' | 'annually'
                        plan_version: version,
                        // plan_quota: quota,
                        plan_monthly_price: price
                    }
                })
            }
        } catch { }
    }

    // 发送请求
    requestStateSet = async (type, st = 0) => {
        const params = {
            name: `${type}`,
            st,
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
            if (typeof data === 'boolean') {
                data = [];
            }
            data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": st, "exp": 0 };
            this.props.setSwitchData(data);
            if (st === 1) {
                this.props.toggleToast(t("Success"));
                setTimeout(() => {
                    utils.routeJump(this, "/dashboard");
                }, 1000)
            }
        } else {
            this.props.toggleToast(t("Try again later"), true)
        }
    }

    componentWillUnmount = async () => {
        // 清除定时器
        this.delTimeArrPreData();
        this.delTimeArrProData();
        this.delTimeArrPreYData();
        this.delTimeArrProYData();
        this.setState = () => false
    }

    render() {
        const {
            state: {
                userInfo,
                selectId,
                openFreePlanDegrade,
                openModalChange,
                openModalLoading,
                modalData,
                moveAnimation,
                // pricingDetailBtnStatus,
                // isSticky,
                prePlanId,
                proPlanId,
                freePlanId,
                prePlanPrice,
                proPlanPrice,
                freePlanPrice,
                prePlanBtnStatus,
                proPlanBtnStatus,
                freePlanBtnStatus,
                preDiscount,
                proDiscount,
                isShowMonth,
                isShowYear,
                old_button,
                // SerSort,
                isShowPricingState,
                oldPayModalStatus,
                preVersionLevel,
                proVersionLevel,
                // isPreJump,
                creditsList,
                purBtnStatus,
                curPurId,
                preDiscountPrice,
                proDiscountPrice,
                preMonthCountDown,
                proMonthCountDown,
                preMonthCountDown_mills,
                proMonthCountDown_mills,
                preYearCountDown,
                proYearCountDown,
                preYearCountDown_mills,
                proYearCountDown_mills,
                isMonthOrYear,
                preMonthPeriod,
                proMonthPeriod,
                preYearPeriod,
                proYearPeriod,
                discountVal,
                disBtnLoading,
                discountValError,
                discountRate,
                discountPlan,
                isShowDisTicket,
                isShowExtraGift,
                appGiftList,
                // isShowGiftBlock,
                paidBtnLoading,
                // googleState,
                cDays,
                cHours,
                cMins,
                cSecs,
                planName,
                diyBannerState,
                isShowFiveModal,
                isShowFeedback,
                isShowReasonSet,
                isShowUpdateSet,
                updateFeedback,
                notExpectVal,
                poorVal,
                lackVal,
                performVal,
                securityVal,
                expensiveVal,
                softwareVal,
                othersVal,
                notExpectInfoVal,
                // poorInfoVal,
                // lackInfoVal,
                // performInfoVal,
                // securityInfoVal,
                // expensiveInfoVal,
                // softwareInfoVal,
                othersInfoVal,
                isShowWarnFeedback,
                sendLoading,
                codeFocus,
                iscacheLoading,
                userReviewArr,
                swiperInx,
                isAsFree,
                asFreeLoading,
                questionList,
                isShowCwComboModal,
                isActLoading,
                isShowCouponDis,
                newPlanService,
                expertPlanBtnStatus,
                isShowAiDouble,
                aiDoubleDate,
                mTabBtnWidth,
                yTabBtnWidth,
                ai_buy_status,
                annualDisText,
                defalutDis,

            },
            setExpanded,
            handleUpdatePricingMeal,
            handleDowngrade,
            purchaseMeal
        } = this;

        // 屏幕宽度
        const wWidth = window.innerWidth;

        // 完成icon
        const FinishIcon = <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.5 5.00002L4.5 8.00002L10.5 2.00002" stroke="#7126ED" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        // 星星
        const starArr = <div className='five_star'>
            {
                [1, 2, 3, 4, 5].map(item => {
                    return <svg key={item} width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.66462 0.613941C7.80477 0.276972 8.28213 0.276972 8.42228 0.61394L10.1177 4.69016C10.1768 4.83221 10.3104 4.92928 10.4637 4.94157L14.8643 5.29437C15.2281 5.32353 15.3756 5.77752 15.0985 6.01494L11.7457 8.88698C11.6288 8.98707 11.5778 9.14412 11.6135 9.29377L12.6378 13.588C12.7225 13.943 12.3363 14.2236 12.0249 14.0334L8.25732 11.7322C8.12602 11.652 7.96089 11.652 7.82959 11.7322L4.06204 14.0334C3.75059 14.2236 3.36441 13.943 3.44908 13.588L4.47342 9.29377C4.50912 9.14412 4.45809 8.98707 4.34125 8.88698L0.988439 6.01494C0.711273 5.77752 0.858783 5.32353 1.22257 5.29437L5.62319 4.94157C5.77655 4.92928 5.91014 4.83221 5.96923 4.69016L7.66462 0.613941Z" fill="#FDB022" />
                    </svg>

                    // <svg key={item} width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    //     <path d="M5.26335 1.10438C5.81357 -0.0104842 7.40334 -0.0104828 7.95356 1.10439L8.8355 2.8914C8.91319 3.04881 9.06336 3.15792 9.23707 3.18316L11.2092 3.46972C12.4395 3.6485 12.9308 5.16046 12.0405 6.02826L10.6135 7.41926C10.4878 7.54179 10.4304 7.71832 10.4601 7.89133L10.797 9.85545C11.0071 11.0808 9.72097 12.0153 8.62053 11.4367L6.85663 10.5094C6.70126 10.4277 6.51564 10.4277 6.36027 10.5094L4.59638 11.4367C3.49594 12.0153 2.20979 11.0808 2.41995 9.85545L2.75683 7.89133C2.7865 7.71832 2.72914 7.54179 2.60344 7.41926L1.17642 6.02826C0.286148 5.16045 0.777414 3.6485 2.00775 3.46972L3.97984 3.18316C4.15355 3.15792 4.30372 3.04881 4.3814 2.8914L5.26335 1.10438Z" fill="#FDAD20" />
                    // </svg>
                })
            }
        </div>

        // 积分套餐
        const integralBox = Boolean(ai_buy_status) && <div className='ai-credits-block'>
            <Collapsible
                open={true}
                id="credits-collapsible"
                transition={{ duration: '200ms', timingFunction: 'ease-in-out' }}
                expandOnPrint
            >
                <Card>
                    <div className='ai-credits-main'>
                        <BlockStack gap={400}>
                            <div className='ac-title'>
                                <div><img src={`/ai/UseAiOpt.png?v=12305`} alt='' /></div>
                                <div className='ac-desc'>
                                    {/* style={{color: '#6C44CD'}} */}
                                    {
                                        isShowAiDouble ? <div>
                                            <Text variant="headingLg" as="h2">{t("Limited-time discount for loyal customers")}&nbsp;<span style={{ fontSize: '14px', color: '#7126FF' }}>{t("ends")}&nbsp;{formatUSATime(aiDoubleDate)}</span></Text>
                                        </div> : <Text variant="headingLg" as="h2"><span>{t("Limited time offer")}</span>&nbsp;{t("for AI Writer credits")}</Text>
                                    }

                                    {/* <p>{t("If you need more credits than what you currently have planned, you can purchase a one-time credits package.")}</p> */}
                                    <p>{t("Used to automatically generate product/blog content.If you need more credits than what you currently have planned, you can purchase a one-time credits package.")}</p>
                                </div>
                            </div>
                            <div className='ac-mealplan'>
                                {creditsList.map(item => {
                                    return <div key={item.level} className="ac-item">
                                        <div className='limit_ai_credits'>
                                            <span className='ac-item-price'>${item.price}</span>
                                            {
                                                isShowAiDouble ? <span>
                                                    <s>{item.points}</s>&nbsp;<span style={{ color: '#7126FF', fontSize: '14px' }}>{item.points * 2}</span> {t("credits")}
                                                </span> : <span className='ac-item-nums'>{item.points} {t("credits")}</span>
                                            }
                                        </div>
                                        <div>
                                            <Button fullWidth onClick={() => purchaseMeal(item.level)} variant='primary' loading={curPurId === item.level || iscacheLoading} disabled={purBtnStatus}>{t("Purchase")}</Button>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </BlockStack>
                    </div>
                </Card>
            </Collapsible>
        </div>

        // 2023.03.14 新版价格页面
        // 滑块类名
        // let sliderClassname = moveAnimation === 1 ? 'tabActive tabActiveFirst' : moveAnimation === 2 ? 'tabActive tabActiveLast' : '';
        // 套餐切换tab栏
        // const pricingTab = ![8, 9].includes(userInfo.ppid) && <section className={`pricingTab ${!pricingDetailBtnStatus && isSticky && 'pricingTabSticky'}`}>
        //     <Card>
        //         <div className='pricingTabContent'>
        //             <div className={sliderClassname}>Silder</div>
        //             <div
        //                 className={`pricingTabItem ${moveAnimation === 1 ? 'pricingTabItemWhite' : ''}`}
        //                 onClick={() => { this.move(1) }}
        //             >
        //                 <span>{t("Monthly")}</span>
        //             </div>
        //             <div
        //                 className={`pricingTabItem ${moveAnimation === 2 ? 'pricingTabItemWhite' : ''}`}
        //                 onClick={() => { this.move(2) }}
        //             >
        //                 <span>{t("One-year")}</span>
        //                 <Badge tone='critical'>-25%</Badge>
        //             </div>
        //         </div>
        //     </Card>
        // </section>

        // 年月费Tab
        const TabPlansBlock = <div className={`pricing-toggle`}>
            <div className="Silder-block" style={{ width: moveAnimation === 1 ? mTabBtnWidth : yTabBtnWidth, left: moveAnimation === 1 ? "10px" : mTabBtnWidth + 15 }}></div>
            <div
                id="monthly"
                className={`toggle-option ${moveAnimation === 1 ? 'monthly-active' : ''}`}
                onClick={() => this.handlePlansToggle(1)}
            >
                {t("Monthly")}
            </div>
            <div
                id="annual"
                className={`toggle-option ${moveAnimation === 2 ? 'annual-active' : ''}`}
                onClick={() => this.handlePlansToggle(2)}
            >
                <span>{t("Annual")}</span>
                <span id="discount" className="discount">{t(annualDisText)}</span>
            </div>
        </div>


        // 专家服务
        // const ExpertServiceBlock = <div className='ExpertServiceBlock'>
        //     <Card>
        //         <div className='EnterprisePlan'>
        //             <div className='left_expert'>
        //                 <div className='le_info'>
        //                     <div className='exterprise'>
        //                         <div className='flex_layout'>
        //                             <Text variant="headingLg" as="h2">{t("Enterprise")} 🛸</Text>
        //                             <div><span className='ep_discount'>{t("{{v1}} OFF", `${40}%`)}</span></div>
        //                         </div>
        //                         <span className='sub_title'>{t("All necessary features for growing businesses")}</span>
        //                     </div>
        //                     <div className='exter_pricing'>$399 <span><s>$660</s>/{t("month")}</span></div>
        //                 </div>
        //                 <div className='re_info'>
        //                     <BlockStack gap={200}>
        //                         {
        //                             expertPlanBtnStatus === 2 ? <Button fullWidth size='large' variant='primary' disabled={Boolean(this.state.paidDisabled)} loading={paidBtnLoading === 10 || iscacheLoading} onClick={this.handleUpdatePricingMealExpert}>{t("Choose this plan")}</Button> :
        //                                 expertPlanBtnStatus === 0 ? <Button fullWidth size='large' variant='primary' disabled loading={iscacheLoading}>{t("Current plan")}</Button> :
        //                                     <Button fullWidth size='large' variant='primary' disabled={Boolean(this.state.paidDisabled)} loading={paidBtnLoading === 10 || iscacheLoading} onClick={this.handleUpdatePricingMealExpert}>{t("Choose this plan")}</Button>
        //                         }
        //                         <Button fullWidth size='large' onClick={this.openBookDemo}>{t("Book Demo")}</Button>
        //                     </BlockStack>
        //                 </div>
        //             </div>
        //             <div className='right_expert'>
        //                 <BlockStack gap={400}>
        //                     <div className='expert_info'>
        //                         <div className="seo-card-container">
        //                             {/* Expert Card */}
        //                             <div className="seo-card">
        //                                 <div className="seo-card-header">{t("1:1 Dedicated SEO Expert")}</div>
        //                                 <div className="seo-card-body expert-card">
        //                                     <div className="expert-info">
        //                                         <div className="expert-image">
        //                                             <img width={64} height={100} src="/pricing/expert.png" alt="" />
        //                                         </div>
        //                                         <div className="expert-details">
        //                                             <h3 className="expert-name">Jenny</h3>
        //                                             <div className="expert-experience">{t("{{v1}} years of service experience", 5)}</div>
        //                                             <div className="expert-stars">{starArr}</div>
        //                                             <div className="expert-tag">{t("Client-focused")}</div>
        //                                         </div>
        //                                     </div>
        //                                 </div>
        //                             </div>

        //                             {/* Enterprise Card */}
        //                             <div className="seo-card">
        //                                 <div className="seo-card-header">{t("Enterprise access")}</div>
        //                                 <div className="seo-card-body">
        //                                     <ul className="feature-list">
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("All features Unlock")}
        //                                         </li>
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("Site speed up by IT expert")}
        //                                         </li>
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("1,000 AI Credit")}
        //                                         </li>
        //                                     </ul>
        //                                 </div>
        //                             </div>

        //                             {/* VIP Services Card */}
        //                             <div className="seo-card">
        //                                 <div className="seo-card-header">{t("VIP services")}</div>
        //                                 <div className="seo-card-body">
        //                                     <ul className="feature-list">
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("VIP problem scanning")}
        //                                         </li>
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("Frequent SEO updates")}
        //                                         </li>
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("SEO Report / month")}
        //                                         </li>
        //                                     </ul>
        //                                 </div>
        //                             </div>

        //                             {/* SEO Optimization Card */}
        //                             <div className="seo-card">
        //                                 <div className="seo-card-header">{t("SEO Optimization suggestions")}</div>
        //                                 <div className="seo-card-body">
        //                                     <ul className="feature-list">
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("15+ recommended keywords")}
        //                                         </li>
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("8+ suggested pages")}
        //                                         </li>
        //                                         <li className="feature-item">
        //                                             <span className="feature-bullet">•</span>{t("More SEO suggestions")}
        //                                         </li>
        //                                     </ul>
        //                                 </div>
        //                             </div>
        //                         </div>
        //                         {/* <div className='expert_detail'>
        //                             <div className='expert_img'><img src='/pricing/expert.png' alt='' /></div>
        //                             <div className='expert_text'>
        //                                 <BlockStack gap={100}>
        //                                     <Text variant="headingMd" as="h2">Jenny</Text>
        //                                     <Text as="p" tone="subdued">{t("{{v1}} years of service experience", 5)}</Text>
        //                                     {starArr}
        //                                     <span>
        //                                         <Badge>{t("Client-focused")}</Badge>
        //                                         <Badge>{t("Dedicated")}</Badge>
        //                                     </span>
        //                                 </BlockStack>
        //                             </div>
        //                         </div>
        //                         <div className='expert_desc'>
        //                             <p>{t("1:1 Expert Consultation")}</p>
        //                             <p>{t("VIP Issue Scan+GSC issues fix")}</p>
        //                             <div>
        //                                 {t("Website Optimization suggestions")}
        //                                 <ul>
        //                                     <li>{t("8+ suggested pages for optimization")}</li>
        //                                     <li>{t("15+ recommended keywords to use")}</li>
        //                                 </ul>
        //                             </div>
        //                             <p>{t("Website Analysis Report / month")}</p>
        //                         </div> */}
        //                     </div>
        //                     <p className='personalized'>{t("Personalized SEO services to help your website achieve rapid ranking improvement.")} <Link target='_blank' url="https://www.seoant.com/uncategorized/enterprise-plan-introduction">{t("View more details")}</Link></p>
        //                 </BlockStack>
        //             </div>
        //         </div>
        //     </Card>
        // </div>

        // 价格套餐子项
        const pricingContentItem = (version, price, btnStatus, current, title = "", info, isShowMonth = false, isShowYear = false, discount = '', ver_level, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills, disPeriod_month = 0, disPeriod_year = 0, infoEnd, forText, aiCredits) => {
            return <section className='pricingContentItem'>
                <div className='pricingContentTop flex_layout' style={(version === 'Free') ? { height: isShowYear ? '82.19px' : '80px' } : {}}>
                    <div className='pricingContentIcon'>
                        <Icon source={version.includes("Free") ? SpeedBasicIcon : version.includes("Pro") ? SpeedFastIcon : SpeedRocketIcon} />
                    </div>
                    <div>
                        <div className="mealVersion">
                            <span>{t(version)}</span>

                        </div>
                        {/* <div className="mealVersionDesc">
                            {desc}
                        </div> */}
                        <div>
                        </div>
                        {/* <div className='sildeLine'></div> */}
                        <div className={`mealPrice ${version.includes("Pre") ? 'pre_mealPrice' : ''}`}>
                            {/* 优惠券和优惠活动折扣力度判断 */}
                            {version === 'Free' ? `$0` : ((userInfo.pro_trial_days > 0 && version.includes("Pro")) || (userInfo.pre_trial_days > 0 && version.includes("Pre"))) ? <span className={`color_tip`}>
                                {/* 优惠券力度大 */}
                                ${isShowYear ? Number(((price * discount) / 12).toFixed(2)) : Number((price * discount).toFixed(2))}
                                {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>&nbsp;/{t("month")}</span> : null}
                                {isShowYear ? <>
                                    <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                    <span className='year_subunit'>{`${t("Total")}: $${Number((price * discount).toFixed(2))} ${t("per year")}`}</span>
                                    {/* <span className='year_subunit'>{`($${Number((price * discount).toFixed(2))} `}<span className='act_price_dis' style={{ fontSize: 14 }}>${price}</span>{` /${t("year")})`}</span> */}
                                </> : null}
                            </span> :
                                discount >= 0 && discount < 1 ? ((Number((price * discount).toFixed(2)) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span className={`${isShowMonth ? 'color_tip' : ''}`}>
                                    {/* 优惠活动力度大 */}
                                    ${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : Number(actMealDiscount.toFixed(2))}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>&nbsp;/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t("Total")}: $${Number(actMealDiscount.toFixed(2))} ${t("per year")}`}</span>
                                        {/* <span className='year_subunit'>{`($${Number(actMealDiscount.toFixed(2))} `}<span className='act_price_dis' style={{ fontSize: 14 }}>${price}</span>{` /${t("year")})`}</span> */}
                                    </> : null}
                                </span> : <span className={`color_tip`}>
                                    {/* 优惠券力度大 */}
                                    ${isShowYear ? Number(((price * discount) / 12).toFixed(2)) : Number((price * discount).toFixed(2))}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>&nbsp;/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t("Total")}: $${Number((price * discount).toFixed(2))} ${t("per year")}`}</span>
                                        {/* <span className='year_subunit'>{`($${Number((price * discount).toFixed(2))} `}<span className='act_price_dis' style={{ fontSize: 14 }}>${price}</span>{` /${t("year")})`}</span> */}
                                    </> : null}
                                </span>) : discount !== 0 && discount >= 1 ? ((Number(price - discount) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span>
                                    {/* 优惠活动力度大 */}
                                    ${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : actMealDiscount}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>&nbsp;/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t("Total")}: $${actMealDiscount === 0 ? 0 : actMealDiscount} ${t("per year")}`}</span>
                                        {/* <span className='year_subunit'>{`($${actMealDiscount === 0 ? 0 : actMealDiscount} `}<span className='act_price_dis' style={{ fontSize: 14 }}>${price}</span>{` /${t("year")})`}</span> */}
                                    </> : null}
                                </span> : <span className={`color_tip`}>
                                    {/* 优惠券力度大 */}
                                    ${isShowYear ? Number(((price - discount) / 12).toFixed(2)) : Number((price - discount).toFixed(2))}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>&nbsp;/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t("Total")}: $${Number((price - discount).toFixed(2)) === 0 ? 0 : Number((price - discount).toFixed(2))} ${t("per year")}`}</span>
                                        {/* <span className='year_subunit'>{`($${Number((price - discount).toFixed(2)) === 0 ? 0 : Number((price - discount).toFixed(2))} `}<span className='act_price_dis' style={{ fontSize: 14 }}>${price}</span>{` /${t("year")})`}</span> */}
                                    </> : null}
                                </span>) : actMealDiscount === -1 ? <span>
                                    ${isShowYear ? ((price * defalutDis) / 12).toFixed(2) : price}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<s>{version.includes("Pro") ? '$39.99' : '$79.99'}</s>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t("Total")}: $${Number((price * defalutDis).toFixed(2))} ${t("per year")}`}</span>
                                    </> : null}
                                </span> : <span className={`color_tip`}>
                                    ${isShowYear ? (actMealDiscount / 12).toFixed(2) : actMealDiscount}
                                    {isShowMonth ? <span className='month_unit price_unit'>&nbsp;<span className='act_price_dis'>${price}</span>/{t("month")}</span> : null}
                                    {isShowYear ? <>
                                        <span className='year_unit price_unit'>&nbsp;<s>${Number((price / 12).toFixed(2))}</s>&nbsp;{`/${t("month")}`}</span>
                                        <span className='year_subunit'>{`${t("Total")}: $${actMealDiscount} ${t("per year")}`}</span>
                                        {/* <span className='year_subunit'>{`($${actMealDiscount} `}<span className='act_price_dis' style={{ fontSize: 14 }}>${price}</span>{` /${t("year")})`}</span> */}
                                    </> : null}
                                </span>
                            }
                        </div>
                    </div>
                </div>
                <div className={`countDownLine ${isMonthOrYear === 2 && 'countDownLineYear'}`} style={{ display: (!isShowCouponDis && !Boolean(planName)) ? 'none' : 'flex' }}>
                    {/* style={{display: preDiscountPrice === 0 && proDiscountPrice === 0 && !Boolean(preDiscount) && !Boolean(proDiscount) ? 'none' : ''}} */}
                    {/* (((discount > 0 && discount < 1) && (Number((price * discount).toFixed(2)) >= actMealDiscount && actMealDiscount !== 0)) || ((discount >= 1) && (Number(price - discount) >= actMealDiscount && actMealDiscount !== 0)) || (!Boolean(discount) && actMealDiscount > 0)) ? */}
                    {
                        version !== 'Free' ? ((isShowYear && Number(cdYear) !== 0) || (isShowMonth && Number(cdMonth) !== 0)) ?
                            <>
                                <div>
                                    {/* 倒计时icon */}
                                    <span>
                                        <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.8645 4.75069C20.6143 2.80855 18.8649 1.20157 16.809 0.103748C16.3865 -0.121832 15.8588 0.0328511 15.6311 0.447488C15.4034 0.862125 15.5588 1.37988 15.9792 1.60331C17.7768 2.56149 19.3028 3.96653 20.3954 5.66375C20.5618 5.92155 20.842 6.0612 21.1311 6.0612C21.2909 6.0612 21.4507 6.01823 21.5952 5.93014C22.0003 5.67664 22.1229 5.15028 21.8645 4.75069ZM10.0413 7.23851C9.56185 7.23851 9.17212 7.62092 9.17212 8.09141V11.8726C9.17869 12.1024 9.2794 12.3087 9.43486 12.4569L11.1667 14.3926C11.3375 14.5838 11.5784 14.6826 11.8192 14.6826C12.0228 14.6826 12.2264 14.6117 12.3928 14.4699C12.7541 14.1584 12.7891 13.6213 12.4717 13.2669L10.9084 11.5202V8.09141C10.9106 7.62092 10.5208 7.23851 10.0413 7.23851Z" fill="#FF0000" />
                                            <path d="M10.9105 1.83104V0.926575C10.9105 0.45608 10.5208 0.0736694 10.0413 0.0736694C9.56179 0.0736694 9.17206 0.45608 9.17206 0.926575V1.87186C8.55244 1.93846 7.93062 2.06092 7.31319 2.24568C1.88328 3.85481 -1.19951 9.4986 0.440413 14.8266C0.58054 15.2777 1.06441 15.5312 1.52421 15.3959C1.984 15.2605 2.24454 14.7836 2.10442 14.3324C0.740372 9.90464 3.30206 5.21473 7.81458 3.87844C12.3271 2.54215 17.1067 5.05361 18.4686 9.48141C19.8326 13.9092 17.2709 18.5991 12.7584 19.9354C9.50705 20.9 5.98199 19.8838 3.77937 17.3466C3.46846 16.9878 2.9189 16.9449 2.55326 17.2499C2.18762 17.555 2.14383 18.0943 2.45473 18.453C4.44497 20.7389 7.32195 22 10.2887 22C11.2805 22 12.2833 21.8582 13.262 21.5682C18.6919 19.9569 21.7725 14.3131 20.1326 8.98728C18.8561 4.83662 15.0837 2.08455 10.9105 1.83104Z" fill="#FF0000" />
                                        </svg>
                                    </span>
                                </div>
                                {isShowYear ? <div>{`${cdYear}:${cdYearMills}`}</div> : <div>{`${cdMonth}:${cdMonthMills}`}</div>}
                            </> : null : null
                    }
                </div>
                {
                    iscacheLoading ? <div className='mealBtn'>
                        <Button size='large' loading={true}>{t("Upgrade")}</Button>
                    </div> : (isAsFree && userInfo.level === 1 && version === 'Free') ? <div className='mealBtn as_free_btn'>
                        <Button size='large' onClick={this.continueAsFree} loading={asFreeLoading}>{t("Continue as free")}</Button>
                    </div> :
                        <div className={`mealBtn btn_${ver_level}_${btnStatus} ${!Boolean(btnStatus) && !this.state.paidLoading && 'mealBtnDisable'}  ${btnStatus === 1 && 'mealDowngrade'}`}>
                            {btnStatus === 3 ? <Button size='large' loading={paidBtnLoading === ver_level} disabled={Boolean(this.state.paidDisabled)} variant='primary' onClick={() => handleUpdatePricingMeal(current, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>
                                {t("Start {{v1}}-day Free Trial", (version.indexOf('Pro') > -1 && userInfo.pro_trial_days) ? userInfo.pro_trial_days : (version.indexOf('Pre') > -1 && userInfo.pre_trial_days) ? userInfo.pre_trial_days : userInfo.trial_days)}
                            </Button> : null}
                            {btnStatus === 2 ? <Button size='large' loading={paidBtnLoading === ver_level} disabled={Boolean(this.state.paidDisabled)} variant='primary' onClick={() => handleUpdatePricingMeal(current, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>{t("Choose this plan")}</Button> : null}
                            {btnStatus === 1 ? <Button size='large' loading={0} disabled={Boolean(this.state.paidDisabled)} onClick={() => handleDowngrade(false)}>{t("Downgrade")}</Button> : null}
                            {btnStatus === 0 ? <Button size='large' loading={0} variant='primary' disabled>{t("Current plan")}</Button> : null}
                        </div>
                }
                <div className={`${isShowYear ? ((preYearPeriod !== 0 || proYearPeriod !== 0) ? 'dis_period' : '') : ((preMonthPeriod !== 0 || proMonthPeriod !== 0) ? 'dis_period' : '')}`}>
                    {
                        isShowYear ?
                            (disPeriod_year !== 0 ? t("Discount for first {{v1}} year only", disPeriod_year) : null) :
                            (disPeriod_month !== 0 ? t("Discount for first {{v1}} month only", disPeriod_month) : null)
                    }
                </div>
                <div className={`${((preYearPeriod !== 0 || proYearPeriod !== 0) || (preMonthPeriod !== 0 || proMonthPeriod !== 0)) ? 'dis_period_info' : ''} mealInfo`}>
                    <div className="mealTitle">
                        {title}
                        {
                            version !== 'Free' ? <p>{forText}</p> : null
                        }
                    </div>
                    {info.map((item, key) => {
                        return <div className="mealInfoItem" key={key}>
                            {/* style={{ display: item === t("Site Speed Up") && version !== 'Free' ? (!googleState ? 'flex' : 'none') :  'flex' }} */}
                            {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C19.9936 4.47982 15.5202 0.00642897 10 0Z" fill="#008060" fillOpacity="0.1"/>
                                <path d="M15.7725 6.83337L10.0683 14.5742C9.93228 14.7547 9.72942 14.873 9.50533 14.9024C9.28124 14.9319 9.05472 14.8701 8.87665 14.7309L4.80331 11.4742C4.44387 11.1866 4.38567 10.662 4.67331 10.3025C4.96096 9.94309 5.48554 9.88489 5.84498 10.1725L9.24165 12.89L14.4308 5.84754C14.601 5.5922 14.8977 5.45103 15.2032 5.48007C15.5086 5.50912 15.7734 5.70368 15.8924 5.98652C16.0114 6.26935 15.9653 6.59469 15.7725 6.83337Z" fill="#008060"/>
                            </svg> */}
                            {/* {FinishIcon} */}
                            <span className='points'>·</span>
                            {
                                version === 'Free' ? (item === t("SEO Checker") ? <Tooltip content={t("Analyze the SEO factors of each page on the website and get suggestions for improvement")}>
                                    <div className={`footer_line`}>{t(item)}</div>
                                </Tooltip> : item === t("AI credits-{{v1}} credits", 30) ? <Tooltip content={
                                    // t("More useful and efficient, AI features can help you quickly generate/optimize content that complies with SEO rules")
                                    t("If you use more than 200 credits, you can keep optimizing for an extra $9.99 for every 100 credits.(you can setting whether to allow automatic deduction)")
                                }>
                                    <div className={`footer_line`}>{t(item)}</div>
                                </Tooltip> : <div>{t(item)}</div>) : <div>{t(item)}</div>
                            }
                        </div>
                    })}
                </div>
                <div className='sildeLineEnd'></div>
                <div className="mealInfoEnd">
                    {infoEnd.map((item, key) => {
                        return <div className="mealInfoItem" key={key}>
                            {/* style={{ display: item === t("Site Speed Up") && version !== 'Free' ? (!googleState ? 'flex' : 'none') :  'flex' }} */}
                            {/* {FinishIcon} */}
                            {
                                key === 0 && version !== 'Free' ? <div onClick={() => {
                                    utils.routeJump(this, "/settings", null, 'overcharge');
                                }}>
                                    <Tooltip content={
                                        <span className='tool_tip'>
                                            {t("If you use more than {{v1}} credits, you can keep optimizing for an extra $9.99 for every 100 credits.(you can", aiCredits)}
                                            <span className='setting_points'>&nbsp;{t("setting")}&nbsp;</span>
                                            {t("whether to allow automatic deduction)")}
                                        </span>
                                    }>
                                        <div className={`footer_line`}>{t(item)}</div>
                                    </Tooltip>
                                </div> : item.includes("Unlimited") ? <div>
                                    {t("On-page SEO Scan") + "-"} <span style={{ color: '#7126ed' }}>{t("Unlimited")}</span> {t("quota")}
                                </div> : item === t("Auto Image Compress -6000 images/month") ? <label style={{ cursor: 'pointer' }} onClick={() => {
                                    utils.routeJump(this, "/settings", null, 'overcharge');
                                }}>
                                    <Tooltip content={<p className='tool_tip'>
                                        {t("If your usage exceeds {{v1}} images, you can continue optimizing, with an additional charge of ${{v2}} for every {{v3}} images.( you can", 6000, 4.99, 1000)}
                                        <span className='setting_points'>&nbsp;{t("setting")}&nbsp;</span>
                                        {t("whether to allow automatic deduction")}
                                    </p>}
                                    >
                                        <div className={`footer_line`}>{t(item)}</div>
                                    </Tooltip>
                                </label> : item === t("Auto Image Compress -2000 images/month") ? <label style={{ cursor: 'pointer' }} onClick={() => {
                                    utils.routeJump(this, "/settings", null, 'overcharge');
                                }}>
                                    <Tooltip content={<p className='tool_tip'>
                                        {t("If your usage exceeds {{v1}} images, you can continue optimizing, with an additional charge of ${{v2}} for every {{v3}} images.( you can", 2000, 4.99, 1000)}
                                        <span className='setting_points'>&nbsp;{t("setting")}&nbsp;</span>
                                        {t("whether to allow automatic deduction")}
                                    </p>}
                                    >
                                        <div className={`footer_line`}>{t(item)}</div>
                                    </Tooltip>
                                </label> : <div>{t(item)}</div>
                            }

                        </div>
                    })}
                </div>
            </section>
        }

        // 价格套餐内容
        const extraIcon = <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4507_23550)">
                <path d="M6.60938 12.0317C6.60938 14.8255 11.3847 17.0894 17.276 17.0894C23.1673 17.0894 27.9427 14.8255 27.9427 12.0317C27.9427 9.23784 23.1673 6.974 17.276 6.974C11.3847 6.974 6.60938 9.23784 6.60938 12.0317ZM17.276 18.6101C12.9188 18.6101 9.17151 17.3717 7.51757 15.5952C6.9343 16.2211 6.60938 16.9136 6.60938 17.6407C6.60938 20.4345 11.3847 22.6983 17.276 22.6983C23.1673 22.6983 27.9427 20.4345 27.9427 17.6407C27.9427 16.9136 27.6178 16.2211 27.0345 15.5979C25.3806 17.3717 21.6333 18.6101 17.276 18.6101ZM17.276 24.3603C12.8629 24.3603 9.07563 23.0899 7.45365 21.2761C6.91033 21.8834 6.60938 22.5492 6.60938 23.2497C6.60938 26.0435 11.3847 28.3073 17.276 28.3073C23.1673 28.3073 27.9427 26.0435 27.9427 23.2497C27.9427 22.5492 27.6418 21.8834 27.0984 21.2761C25.4765 23.0872 21.6892 24.3603 17.276 24.3603Z" fill="white" />
                <path d="M27.7079 1.68967C27.9227 1.10926 28.7436 1.10926 28.9584 1.68967L29.4872 3.11875C29.5547 3.30123 29.6986 3.4451 29.8811 3.51263L31.3102 4.04143C31.8906 4.2562 31.8906 5.07713 31.3102 5.2919L29.8811 5.82071C29.6986 5.88823 29.5547 6.0321 29.4872 6.21458L28.9584 7.64366C28.7436 8.22408 27.9227 8.22407 27.7079 7.64366L27.1791 6.21458C27.1116 6.0321 26.9677 5.88823 26.7853 5.82071L25.3562 5.2919C24.7758 5.07713 24.7758 4.2562 25.3562 4.04143L26.7853 3.51263C26.9677 3.4451 27.1116 3.30123 27.1791 3.11875L27.7079 1.68967Z" fill="white" />
                <path d="M1.7081 17.6897C1.92287 17.1093 2.7438 17.1093 2.95857 17.6897L3.12725 18.1455C3.19478 18.328 3.33865 18.4719 3.52113 18.5394L3.977 18.7081C4.55741 18.9229 4.55741 19.7438 3.977 19.9586L3.52113 20.1273C3.33865 20.1948 3.19478 20.3387 3.12725 20.5211L2.95857 20.977C2.7438 21.5574 1.92287 21.5574 1.7081 20.977L1.53941 20.5211C1.47189 20.3387 1.32802 20.1948 1.14554 20.1273L0.689669 19.9586C0.109257 19.7438 0.109258 18.9229 0.68967 18.7081L1.14554 18.5394C1.32802 18.4719 1.47189 18.328 1.53941 18.1455L1.7081 17.6897Z" fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_4507_23550">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>

        // const triangleIcon = <svg t="1709033045407" className="icon" viewBox="0 0 1536 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15797" width="30" height="30"><path d="M608.69643527 816.90437621c88.12985382 113.41208553 231.11965681 113.28338181 319.12080693 4e-8l476.87131471-489.26708917c88.12985382-113.41208553 42.69745017-205.31456633-100.28430882-205.31456633l-1072.2948187-1e-8c-143.50461777 0-188.28545895 92.09553635-100.28430884 205.37891818L608.63208342 816.90437621l0.06435185 4e-8z" fill="#7126ed" p-id="15798"></path></svg>
        const pricingMealContent = <div className='pricingMealContent' id='pricingMealContent'>
            <Layout>
                <Layout.Section variant="oneThird">
                    <div className='mealRecommended'>
                        {/* (userInfo.level === 1 && !isPreJump) &&  */}
                        <div className='Most_popular'>{t("Most popular")}</div>
                        {/* <div className='mealRecommendedHead PreRecommand'>
                            {t("Recommended")}
                            <span className='triangle_icon'>{triangleIcon}</span>
                        </div> */}
                        {/* {
                            isShowGiftBlock && <div className='mealRecommendedHead flex_layout' onClick={this.showExtraGiftModal}>
                                {extraIcon} <span className='gift_text'>
                                    <span>{t("$130")}</span>
                                    <span> {t("extra benefits")}</span>
                                </span>
                                <span className='triangle_icon'>{triangleIcon}</span>    
                            </div>
                        } */}
                        <div className='mealRecommendedBg'></div>
                        <Card>{pricingContentItem(
                            'Pre Plan',
                            // t("Advanced SEO with a high number of products"),
                            prePlanPrice,
                            prePlanBtnStatus,
                            prePlanId,
                            t("All pro plan features, plus:"),
                            [
                                `${t("Rocket site Speed up")} ⚡⚡`,
                                "Monitor your website's keywords", t("Competitor's keywords-{{v1}} website/month, {{v2}} in total", 10, 50), "AMP", "Backlink Audit"],
                            isShowMonth,
                            isShowYear,
                            preDiscount,
                            preVersionLevel,
                            preDiscountPrice,
                            preMonthCountDown,
                            preMonthCountDown_mills,
                            preYearCountDown,
                            preYearCountDown_mills,
                            preMonthPeriod,
                            preYearPeriod,
                            [
                                t("AI credits-{{v1}} credits", 500) + "/" + t("month"), "On-page SEO Scan-Unlimited quota", t("Auto Image Compress -6000 images/month"), t("Exchange Backlinks-1000 quota")],
                            t("For medium businesses"),
                            500,
                        )}</Card>
                    </div>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <div className='mealRecommended'>
                        {/* {(userInfo.level === 1 && !isPreJump) && <div className='mealRecommendedHead'>{t("Recommended")}</div>} */}
                        <Card>{pricingContentItem(
                            'Pro Plan',
                            // t("More automation functions to Boost Your SEO quickly"),
                            proPlanPrice,
                            proPlanBtnStatus,
                            proPlanId,
                            t("All free features, plus:"),
                            [
                                `${t("Fast site speed up")} ⚡`,
                                "Auto repair broken links", "Auto-optimization Meta Tags", "Google Analytics", "JSON-LD snippets", "Local Business", "Instant Index"],
                            isShowMonth,
                            isShowYear,
                            proDiscount,
                            proVersionLevel,
                            proDiscountPrice,
                            proMonthCountDown,
                            proMonthCountDown_mills,
                            proYearCountDown,
                            proYearCountDown_mills,
                            proMonthPeriod,
                            proYearPeriod,
                            [
                                t("AI credits-{{v1}} credits", 200) + "/" + t("month"), `${t("On-page SEO Scan-{{v1}} quota", 1000)}`, t("Auto Image Compress -2000 images/month"), t("Exchange Backlinks-300 quota")],
                            t("For small businesses"),
                            200,
                        )}</Card>
                    </div>
                </Layout.Section>
                <Layout.Section variant="oneThird">
                    <Card>{pricingContentItem(
                        'Free',
                        // t("All the basic functions of your basic SEO"),
                        freePlanPrice,
                        freePlanBtnStatus,
                        freePlanId,
                        t("Functions included are:"),
                        [
                            t("Basic site speed up"), t("SEO Checker"), t("Auto scan broken links"), t("Bulk Edit image alt text"), t("Keyword Suggestion Tool"), t("HTML Sitemap")
                        ],
                        isShowMonth,
                        isShowYear,
                        1,
                        '',
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        [
                            // t("AI credits-8 credits"), t("On-page SEO Optimization-20 quota"), t("Auto Image Compress -50 images"), t("Exchange Backlinks-40 quota"), t("View page ranking-10 pages")
                            t("AI credits-{{v1}} credits", 30), t("On-page SEO Scan-{{v1}} quota", 20), t("Auto Image Compress -50 images"), t("Exchange Backlinks-40 quota")
                        ],
                        '',
                        30
                    )}</Card>
                </Layout.Section>
            </Layout>
        </div>

        // 特性价格标题块
        const pricingTopBlock = (version, price, btnStatus, selectId, isFree = false, discount = '', ver_level, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills) => {
            return <section className='pricingTopBlock'>
                <div className="mealVersion">
                    {t(version)}
                </div>
                <div className={`mealPrice`} style={{ minHeight: preDiscountPrice === 0 && proDiscountPrice === 0 ? '22px' : '30px' }}>
                    {isFree ? <span>{t("Free")}
                        {
                            isShowYear && <span className='year_subunit' style={{ opacity: 0, minHeight: '25px' }}>{t("occupied")}</span>
                        }
                    </span> : version === "Enterprise" ? <div>
                        {/* {`$${price}`}
                        <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                        {
                            isShowYear && <span className='year_subunit' style={{ opacity: 0, minHeight: '20px' }}>{t("occupied")}</span>
                        } */}
                    </div> : ((version.indexOf('Pro') > -1 && userInfo.pro_trial_days > 0) || (version.indexOf('Pre') > -1 && userInfo.pre_trial_days > 0)) ? <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                        <span className='act_price_dis'>${isShowYear ? Number(((price * discount) / 12).toFixed(2)) : Number((price * discount).toFixed(2))}</span>
                        {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                        {isShowYear ? <>
                            <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                            <span className='year_subunit'>{`${t("Total")}: $${Number(((price * discount)).toFixed(2))} ${t("per year")}`}</span>
                            {/* <span className='year_subunit'>{`($${Number((price * discount).toFixed(2))}/${t("year")})`}</span> */}
                        </> : null}
                    </span> :
                        discount >= 0 && discount < 1 ? ((Number((price * discount).toFixed(2)) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : Number(actMealDiscount.toFixed(2))}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t("Total")}: $${actMealDiscount} ${t("per year")}`}</span>
                                {/* <span className='year_subunit'>{`($${Number(actMealDiscount.toFixed(2))}/${t("year")})`}</span> */}
                            </> : null}
                        </span> : <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number(((price * discount) / 12).toFixed(2)) : Number((price * discount).toFixed(2))}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t("Total")}: $${Number(((price * discount)).toFixed(2))} ${t("per year")}`}</span>
                                {/* <span className='year_subunit'>{`($${Number((price * discount).toFixed(2))}/${t("year")})`}</span> */}
                            </> : null}
                        </span>) : discount !== 0 && discount >= 1 ? ((Number(price - discount) >= actMealDiscount && Boolean(actMealDiscount >= 0)) ? <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            ${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : actMealDiscount}
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t("Total")}: $${actMealDiscount} ${t("per year")}`}</span>
                                {/* <span className='year_subunit'>{`($${actMealDiscount}/${t("year")})`}</span> */}
                            </> : null}
                        </span> : <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number(((price - discount) / 12).toFixed(2)) : Number((price - discount).toFixed(2))}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t("Total")}: $${Number(((price - discount)).toFixed(2))} ${t("per year")}`}</span>
                                {/* <span className='year_subunit'>{`($${Number((price - discount).toFixed(2))}/${t("year")})`}</span> */}
                            </> : null}
                        </span>) : actMealDiscount === -1 ? <span>
                            ${isShowYear ? Number(((price * defalutDis) / 12).toFixed(2)) : <span>{price}</span>}
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t("Total")}: $${Number(((price * defalutDis)).toFixed(2))} ${t("per year")}`}</span>
                                {/* <span className='year_subunit'>{`($${price}/${t("year")})`}</span> */}
                            </> : null}
                        </span> : <span className={`${preDiscountPrice === 0 && proDiscountPrice === 0 ? '' : 'color_tip'}`}>
                            <span className='act_price_dis'>${isShowYear ? Number((actMealDiscount / 12).toFixed(2)) : actMealDiscount}</span>
                            {isShowMonth ? <span className='month_unit price_unit'>&nbsp;/{t("month")}</span> : null}
                            {isShowYear ? <>
                                <span className='year_unit price_unit'>&nbsp;{`/${t("month")}`}</span>
                                <span className='year_subunit'>{`${t("Total")}: $${actMealDiscount} ${t("per year")}`}</span>
                                {/* <span className='year_subunit'>{`($${actMealDiscount}/${t("year")})`}</span> */}
                            </> : null}
                        </span>
                    }
                </div>
                <div className={`countDownLine ${isMonthOrYear === 2 && 'countDownLineYear'}`} style={!((isShowMonth && (Number(proMonthCountDown) !== 0 || Number(preMonthCountDown) !== 0)) || (isShowYear && (Number(proYearCountDown) !== 0 || Number(preYearCountDown) !== 0))) ? { height: 0 } : {}}>
                    {/* style={{display: preDiscountPrice === 0 && proDiscountPrice === 0 ? 'none' : ''}} */}
                    {/* (((discount > 0 && discount < 1) && (Number((price * discount).toFixed(2)) >= actMealDiscount && actMealDiscount !== 0)) || ((discount >= 1) && (Number(price - discount) >= actMealDiscount && actMealDiscount !== 0)) || (!Boolean(discount) && actMealDiscount > 0)) ? */}
                    {
                        version !== 'Free' ? (isShowYear && Number(cdYear) !== 0) || (isShowMonth && Number(cdMonth) !== 0) ?
                            <>
                                <div>
                                    {/* 倒计时icon */}
                                    <span>
                                        <svg width="16" height="16" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21.8645 4.75069C20.6143 2.80855 18.8649 1.20157 16.809 0.103748C16.3865 -0.121832 15.8588 0.0328511 15.6311 0.447488C15.4034 0.862125 15.5588 1.37988 15.9792 1.60331C17.7768 2.56149 19.3028 3.96653 20.3954 5.66375C20.5618 5.92155 20.842 6.0612 21.1311 6.0612C21.2909 6.0612 21.4507 6.01823 21.5952 5.93014C22.0003 5.67664 22.1229 5.15028 21.8645 4.75069ZM10.0413 7.23851C9.56185 7.23851 9.17212 7.62092 9.17212 8.09141V11.8726C9.17869 12.1024 9.2794 12.3087 9.43486 12.4569L11.1667 14.3926C11.3375 14.5838 11.5784 14.6826 11.8192 14.6826C12.0228 14.6826 12.2264 14.6117 12.3928 14.4699C12.7541 14.1584 12.7891 13.6213 12.4717 13.2669L10.9084 11.5202V8.09141C10.9106 7.62092 10.5208 7.23851 10.0413 7.23851Z" fill="#FF0000" />
                                            <path d="M10.9105 1.83104V0.926575C10.9105 0.45608 10.5208 0.0736694 10.0413 0.0736694C9.56179 0.0736694 9.17206 0.45608 9.17206 0.926575V1.87186C8.55244 1.93846 7.93062 2.06092 7.31319 2.24568C1.88328 3.85481 -1.19951 9.4986 0.440413 14.8266C0.58054 15.2777 1.06441 15.5312 1.52421 15.3959C1.984 15.2605 2.24454 14.7836 2.10442 14.3324C0.740372 9.90464 3.30206 5.21473 7.81458 3.87844C12.3271 2.54215 17.1067 5.05361 18.4686 9.48141C19.8326 13.9092 17.2709 18.5991 12.7584 19.9354C9.50705 20.9 5.98199 19.8838 3.77937 17.3466C3.46846 16.9878 2.9189 16.9449 2.55326 17.2499C2.18762 17.555 2.14383 18.0943 2.45473 18.453C4.44497 20.7389 7.32195 22 10.2887 22C11.2805 22 12.2833 21.8582 13.262 21.5682C18.6919 19.9569 21.7725 14.3131 20.1326 8.98728C18.8561 4.83662 15.0837 2.08455 10.9105 1.83104Z" fill="#FF0000" />
                                        </svg>
                                    </span>
                                </div>
                                {isShowYear ? <div>{`${cdYear}:${cdYearMills}`}</div> : <div>{`${cdMonth}:${cdMonthMills}`}</div>}
                            </> : null : null
                    }
                </div>
                {
                    iscacheLoading ? <div className='mealBtn'>
                        <Button loading={true}>{t("Upgrade")}</Button>
                    </div> : (isAsFree && userInfo.level === 1 && isFree) ? <div className='mealBtn as_free_btn'>
                        <Button onClick={this.continueAsFree} loading={asFreeLoading}>{t("Continue as free")}</Button>
                    </div> :
                        <div className={`mealBtn btn_${ver_level}_${btnStatus} ${!Boolean(btnStatus) && !this.state.paidLoading && 'mealBtnDisable'}  ${btnStatus === 1 && 'mealDowngrade'}`}>
                            {btnStatus === 3 ? <Button disabled={this.state.paidDisabled} loading={paidBtnLoading === ver_level} variant='primary' onClick={() => handleUpdatePricingMeal(selectId, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>
                                {t("Start {{v1}}-day Free Trial", (version.indexOf('Pro') > -1 && userInfo.pro_trial_days) ? userInfo.pro_trial_days : (version.indexOf('Pre') > -1 && userInfo.pre_trial_days) ? userInfo.pre_trial_days : userInfo.trial_days)}
                            </Button> : null}
                            {btnStatus === 2 ? <Button disabled={this.state.paidDisabled} loading={paidBtnLoading === ver_level} variant='primary' onClick={() => handleUpdatePricingMeal(selectId, price, ver_level, { discount, actMealDiscount, cdMonth, cdMonthMills, cdYear, cdYearMills })}>{t("Choose this plan")}</Button> : null}
                            {btnStatus === 1 ? <Button disabled={this.state.paidDisabled} loading={0} onClick={() => handleDowngrade(false)}>{t("Downgrade")}</Button> : null}
                            {btnStatus === 0 ? <Button loading={0} variant='primary' disabled>{t("Current plan")}</Button> : null}
                        </div>
                }
            </section>
        }
        const pricingTitleBlock = <div className='pricing_title_block' style={{ position: 'sticky', top: (window.shopify) ? '0' : '3.5rem' }}>
            <div className='pt_item pt_first'></div>
            <div className='pt_item pt_free'>
                {
                    pricingTopBlock(
                        "Free plan",
                        freePlanPrice,
                        freePlanBtnStatus,
                        freePlanId,
                        true,
                        '',
                        '',
                        0,
                        0,
                        0,
                        0,
                        0,
                    )
                }
            </div>
            <div className='pt_item pt_pro'>
                {
                    pricingTopBlock(
                        "Pro plan",
                        proPlanPrice,
                        proPlanBtnStatus,
                        proPlanId,
                        false,
                        proDiscount,
                        proVersionLevel,
                        proDiscountPrice,
                        proMonthCountDown,
                        proMonthCountDown_mills,
                        proYearCountDown,
                        proYearCountDown_mills,
                    )
                }
            </div>
            <div className='pt_item pt_pre'>
                {
                    pricingTopBlock(
                        "Pre plan",
                        prePlanPrice,
                        prePlanBtnStatus,
                        prePlanId,
                        false,
                        preDiscount,
                        preVersionLevel,
                        preDiscountPrice,
                        preMonthCountDown,
                        preMonthCountDown_mills,
                        preYearCountDown,
                        preYearCountDown_mills,
                    )
                }
            </div>
        </div>
        // 价格等级特性列
        // const SerList = Object.keys(SerSort).reverse();
        const pricingState = <Collapsible
            open={isShowPricingState}
            id="pricing-detail-collapsible"
        >
            {window.innerWidth > 900 && pricingTitleBlock}
            {/* <div className='pricing_state_main'>
                {
                    Object.keys(SerSort['serTitle']).map((title, tinx) => {
                        return <div key={title} className="ps_block">
                            <div className='ps_title'>
                                {
                                    tinx === Object.keys(SerSort['serTitle']).length - 1 ? <span style={{ borderBottom: 'unset' }}>{t(title)}</span> :
                                        <Tooltip content={t(SerSort['serTitle'][title].tips)}>
                                            <span>{t(title)}</span>
                                        </Tooltip>
                                }
                            </div>
                            <div className='ps_submain'>
                                {
                                    Object.keys(SerSort['serTitle'][title].subText).map(sub => {
                                        return <div key={sub} className="ps_subtitle">
                                            {
                                                SerList.map((ser, sinx) => {
                                                    return <div key={ser} className={`ps_itemText ${ser === 'serTitle' ? 'ps_first' : 'ps_item'}`}>
                                                        {sinx === 0 ? t(sub) : (
                                                            SerSort['serTitle'][title].subText[sub] === 1 || SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] === true ?
                                                                FinishIcon : sub === 'Auto image compress' ? <div>
                                                                    {
                                                                        sinx === 1 ? <label style={{ cursor: 'pointer' }} onClick={() => {
                                                                            utils.routeJump(this, "/settings");
                                                                        }}>
                                                                            <Tooltip persistOnClick content={
                                                                                sinx === 1 ?
                                                                                    <p>{t("If your usage exceeds {{v1}} images, you can continue optimizing, with an additional charge of ${{v2}} for every {{v3}} images.( you can")}<span style={{ color: '#005BD3', display: 'inline-block' }}>&nbsp;{t("setting")}&nbsp;</span>{t("whether to allow automatic deduction")}</p>
                                                                                    : ""
                                                                            }>
                                                                                <div className='image_auto_pricing' style={{ borderBottom: '1px dashed #ccc' }}>
                                                                                    <span>{`${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]]} ${sinx !== 3 ? t("images/month") : 'images'}`}</span>
                                                                                </div>
                                                                            </Tooltip>
                                                                        </label> : t(`${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]]} images${sinx !== 3 ? '/month' : ''}`)
                                                                    }
                                                                </div> : sub === 'On-page SEO Optimization' ? `${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] === 0 ? t("unlimited") : SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] + ' ' + t("quota") + (sinx === 2 ? '/' + t("month") : '')}` : sub === 'Exchange backlink quota' ? t(`${sinx === 1 ? 1000 : sinx === 2 ? 300 : 40}`) : sub === 'Competitor's keywords' ? t(`${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] === 0 ? '--' : SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] + ' website/month'}`) : sub === 'Keywords Library-my keywords' ? `${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] === 0 ? '--' : SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] + ' keywords'}` : sub === 'AI Writer credits' ? `${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]]} ${t("credits")}${sinx !== 3 ? '/' + t("month") : ''}` : sub === "View page ranking" ? `${SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]]} ${t("pages")}` : SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] === false || SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]] === 0 ?
                                                                    '--' : SerSort[SerList[sinx]][SerSort['serTitle'][title].subText[sub]]
                                                        )}
                                                    </div>
                                                })
                                            }
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div> */}
            <div className='pricing_state_main'>
                {
                    Object.keys(newPlanService).map(title => {
                        return <div key={title} className="ps_block">
                            <div className='ps_title'>
                                {
                                    !Boolean(newPlanService[title].other.desc) ? <span style={{ borderBottom: 'unset' }}>{t(title)}</span> :
                                        Boolean(newPlanService[title].other.isSub) ? <label style={{ cursor: 'pointer' }} onClick={() => this.jumpUrl(newPlanService[title].other.url)}>
                                            <Tooltip content={
                                                <span>
                                                    {t(newPlanService[title].other.desc)}&nbsp;
                                                    <span style={{ color: '#005bd3' }}>{t(newPlanService[title].other.subdesc)}</span>
                                                </span>
                                            }>
                                                <span>{t(title)}</span>
                                            </Tooltip>
                                        </label> : <Tooltip content={t(newPlanService[title].other.desc)}>
                                            <span>{t(title)}</span>
                                        </Tooltip>
                                }
                            </div>
                            <div className='ps_submain'>
                                {
                                    Object.keys(newPlanService[title]).map(son => {
                                        return son === "other" ? null : <div key={son} className="ps_subtitle">
                                            {
                                                son === "All Pages SEO Scan" ? <div className={`ps_itemText ps_first`}><Tooltip content={t("We continuously scan all your store pages for SEO issues.")}><span>{t(son)}</span></Tooltip></div> : 
                                                son === "On-page SEO Optimization" ? <div className={`ps_itemText ps_first`}><Tooltip content={t("When you edit a page, we'll re-scan it automatically using 1 credit —— only once per page.")}><span>{t(son)}</span></Tooltip></div> : 
                                                son === "Rank Tracking" ? <div className={`ps_itemText ps_first`}><Tooltip content={t("SEOAnt automatically tracks and monitors your website's indexed keywords.")}><span>{t(son)}</span></Tooltip></div> : <div className={`ps_itemText ps_first`}>{t(son)}</div>
                                            }
                                            {
                                                newPlanService[title][son].map((child, cinx) => {
                                                    return <div key={child + cinx} className="ps_itemText ps_item">
                                                        {
                                                            child === '--' ? child :
                                                                typeof child === "boolean" ? FinishIcon :
                                                                    child === -1 ? t("Unlimited") :
                                                                        (title === "Image Optimization" && son === "Auto image compress" && cinx >= 1) ? <label style={{ cursor: 'pointer' }} onClick={() => {
                                                                            utils.routeJump(this, "/settings", null, 'overcharge');
                                                                        }}>
                                                                            <Tooltip persistOnClick content={
                                                                                <p>{t("If your usage exceeds {{v1}} images, you can continue optimizing, with an additional charge of ${{v2}} for every {{v3}} images.( you can", cinx === 1 ? 2000 : 6000, 4.99, 1000)}<span style={{ color: '#005BD3', display: 'inline-block' }}>&nbsp;{t("setting")}&nbsp;</span>{t("whether to allow automatic deduction")}</p>
                                                                            }>
                                                                                <span style={{ borderBottom: '1px dashed #ddd', paddingBottom: '2px' }}>{t(child)} {t(newPlanService[title].other.unit)}/{t("month")}</span>
                                                                            </Tooltip>
                                                                        </label> :
                                                                            title === "Content Optimization" ? (
                                                                                child === -1 ? t("Unlimited") : child + " " + `${son === "AI Writer credits" ? t("credits") : t("quota")}${cinx === 0 || son !== "AI Writer credits" ? "" : "/" + t("month")}`
                                                                            ) :
                                                                                title === "Keywords" ? (
                                                                                    son === "Competitor's keywords" ? `${t("{{v1}} sites/month, {{v2}} in total", child, 50)}` :
                                                                                        // son === "Keyword List" ? `${child} ${t(newPlanService[title].other["unit-kl"])}` :
                                                                                        son === "View page ranking" ? `${child} ${t(newPlanService[title].other["unit-vpr"])}` : null
                                                                                ) :
                                                                                    (newPlanService[title].other.isMonth ? `${child} ${t(newPlanService[title].other.unit)}${cinx === 0 ? "" : "/" + t("month")}` : t(child))
                                                        }
                                                    </div>
                                                })
                                            }
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div>
        </Collapsible>


        // 价格套餐详细按钮
        const pricingDetailBtn = <div className='pricingDetailMain'>
            <div className={`pricingDetailBtn ${isShowPricingState ? 'pdb_show' : ''}`} onClick={() => setExpanded(!isShowPricingState)}>
                <div>{!isShowPricingState ? t("Show detail feature of pricing plans") : t("Hide detail feature of pricing plans")}</div>
                <Icon tone='base' source={isShowPricingState ? ChevronUpMinor : ChevronDownMinor} />
            </div>
            {pricingState}
        </div>

        // 用户评价展示
        const userReviewBox = <Card>
            <div className='ur_title'>
                <Text variant="headingMd" as="h2">{t("SEOAnt leads your website to success!")}</Text>
            </div>
            <Swiper
                ref={this.swiperRef}
                slidesPerView={"auto"}
                loop={true}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                modules={[Autoplay, Pagination, Navigation]}
                spaceBetween={10}
                onSlideChange={this.onSlideChangeInx}
            >
                {
                    Object.values(userReviewArr).map((item, index) => {
                        return <SwiperSlide key={index}>
                            <div className='user_review_card'>
                                <InlineGrid columns={wWidth >= 1000 ? 3 : wWidth >= 700 ? 2 : 1} gap={400}>
                                    {
                                        item.map(son => {
                                            return <Card key={son.id}>
                                                <BlockStack gap={200}>
                                                    {starArr}
                                                    <p className={`${index === 1 ? 'user_desc' : ''}`}>{son.desc}</p>
                                                    <div className='user_info'>
                                                        <img src={son.img} alt='' />
                                                        <div>
                                                            <h2>{son.user}</h2>
                                                            <p>{son.state}</p>
                                                        </div>
                                                    </div>
                                                </BlockStack>
                                            </Card>
                                        })
                                    }
                                </InlineGrid>
                            </div>
                        </SwiperSlide>
                    })
                }
            </Swiper>
            <div className='click_line'>
                <div className={`c_point ${swiperInx === 1 ? 'active' : ''}`} onClick={() => this.handlSliedChange(1)}></div>
                <div className={`c_point ${swiperInx === 2 ? 'active' : ''}`} onClick={() => this.handlSliedChange(2)}></div>
            </div>
        </Card>

        //这里有四个弹窗
        const upgradeModalTextByDisposable = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used {{v1}} for {{v2}} days, it still has $ {{v3}} left.", this.state.modalData.now_plan, this.state.modalData.after_days, this.state.modalData.balance)}
                <br /> <br />
                {t("Now you want to upgrade to Premium Plan, we will change this $")}{this.state.modalData.balance} {t("to premium plan(half year), at the price of the premium plan(half year), you will be able to use the premium plan(half year) for")} {this.state.modalData.change_days} {t("days.")}
                <br /> <br />
                {t("Are you sure to change ?")}
                <br /> <br />
                <span style={{ color: "red" }}>{t("Notice:This process is irreversible!")}</span>
            </p>
        )
        const degradeModalTextByDisposable = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used {{v1}} for {{v2}} days, it still has $ {{v3}} left.", this.state.modalData.now_plan, this.state.modalData.after_days, this.state.modalData.balance)}
                <br /> <br />
                {t("Now you want to degrade to Pro Plan, we will change this $")}{this.state.modalData.balance} {t("to Pro Plan(half year), at the price of the Pro Plan(half year), you will be able to use the Pro Plan(half year) for")} {this.state.modalData.change_days} {t("days.")}
                <br /> <br />
                {t("Are you sure to change ?")}
                <br /> <br />
                <span style={{ color: "red" }}>{t("Notice:This process is irreversible!")}</span>
            </p>
        )
        const upgradeModalTextBySubscription = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used Pro Plan(per month) for")}&nbsp;{this.state.modalData.charge_days} {t("days, If you switch to the premium plan(per month), the old recurring bill will be closed and charged for")} {this.state.modalData.charge_days} {t("days, then the new recurring bill will start charging.")}
                <br /><br />
                {t("Are you sure to change ?")}
            </p>
        )
        const degradeModalTextBySubscription = this.state.modalData.length === 0 ? null : (
            <p>
                {t("You have used premium plan(per month) for")}&nbsp;{this.state.modalData.charge_days} {t("days, If you switch to the Pro Plan(per month), the old recurring bill will be closed and charged for")} {this.state.modalData.charge_days} {t("days, then the new recurring bill will start charging.")}
                <br /><br />
                {t("Are you sure to change ?")}
            </p>
        )

        //首字母大写
        const pageModalTitle = (str) => { return str.replace(str[0], str[0].toUpperCase()); };
        //升降级弹窗
        const pageModal = modalData.length === 0 ? null : (
            <div>
                <Modal
                    open={openModalChange}
                    onClose={() => { this.setState({ openModalChange: !openModalChange }) }}
                    title={modalData.change_type !== undefined ? pageModalTitle(modalData.change_type) : null}
                    primaryAction={{
                        content: t("YES"),
                        onAction: () => { this.updatePlanConversion(selectId, modalData.pay_type) },
                        loading: openModalLoading
                    }}
                    secondaryActions={[
                        {
                            content: t("NO"),
                            onAction: () => { this.setState({ openModalChange: !openModalChange }) },
                        },
                    ]}
                >
                    <Modal.Section>
                        <BlockStack>
                            {modalData.pay_type === 1 ? modalData.change_type === 'upgrade' ? upgradeModalTextByDisposable : degradeModalTextByDisposable : null}
                            {modalData.pay_type === 2 ? modalData.change_type === 'upgrade' ? upgradeModalTextBySubscription : degradeModalTextBySubscription : null}
                        </BlockStack>
                    </Modal.Section>
                </Modal>
            </div>)

        // 反馈弹窗
        const feedbackModal = <Modal
            open={isShowFeedback}
            title={<span className='flex_layout'>
                <span>{t("We need your feedback")}</span>
                <img style={{ width: '25px' }} src='/face/Pleading.png' alt='Pleading' />
            </span>}
            primaryAction={[
                {
                    content: t("OK"),
                    onAction: this.sendFeedbackInfo,
                    loading: sendLoading,
                },
            ]}
            onClose={this.closeNeedFeedback}
        >
            <div className='modal_padding'>
                <BlockStack gap={300}>
                    {
                        isShowWarnFeedback && <Banner
                            tone="warning"
                            title={t(isShowWarnFeedback)}
                            onDismiss={() => {
                                this.setState({ isShowWarnFeedback: false })
                            }}
                        ></Banner>
                    }
                    <p>{t("Your feedback is important to us and helps us better serve your needs and those of other users. Thank you for your time and support!")}</p>
                    <div className='feedback_one feedback_main'>
                        <p className='fb_items' onClick={() => this.openFeedbackSet(1)}>
                            <span>*</span>
                            <span>{t("What is the reason why you want to uninstall SEOAnt ? (Please select all that apply)")}</span>
                            <Icon source={ChevronRightMinor} />
                        </p>
                        <Collapsible
                            open={isShowReasonSet}
                        >
                            <div className='reason_list'>
                                <div>
                                    <Checkbox
                                        label={t("Function not as expected")}
                                        id='notExpectVal'
                                        checked={notExpectVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {
                                        notExpectVal && <TextField
                                            id='notExpectInfoVal'
                                            value={notExpectInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={2}
                                            placeholder={t("Could you please specify which function does not meet your expectations? We will improve it based on your suggestions.")}
                                            autoComplete="off"
                                        />
                                    }
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("Poor user interface experience")}
                                        id='poorVal'
                                        checked={poorVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {/* {
                                        poorVal && <TextField
                                            id='poorInfoVal'
                                            value={poorInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={3}
                                            autoComplete="off"
                                        />
                                    } */}
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("Lack of required features or content")}
                                        id='lackVal'
                                        checked={lackVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {/* {
                                        lackVal && <TextField
                                            id='lackInfoVal'
                                            value={lackInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={3}
                                            autoComplete="off"
                                        />
                                    } */}
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("Performance issues (such as lags, crashes, etc.)")}
                                        id='performVal'
                                        checked={performVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {/* {
                                        performVal && <TextField
                                            id='performInfoVal'
                                            value={performInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={3}
                                            autoComplete="off"
                                        />
                                    } */}
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("security concerns")}
                                        id='securityVal'
                                        checked={securityVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {/* {
                                        securityVal && <TextField
                                            id='securityInfoVal'
                                            value={securityInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={3}
                                            autoComplete="off"
                                        />
                                    } */}
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("Too expensive")}
                                        id='expensiveVal'
                                        checked={expensiveVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {/* {
                                        expensiveVal && <TextField
                                            id='expensiveInfoVal'
                                            value={expensiveInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={3}
                                            autoComplete="off"
                                        />
                                    } */}
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("There is more suitable software to use")}
                                        id='softwareVal'
                                        checked={softwareVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {/* {
                                        softwareVal && <TextField
                                            id='softwareInfoVal'
                                            value={softwareInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={3}
                                            autoComplete="off"
                                        />
                                    } */}
                                </div>
                                <div>
                                    <Checkbox
                                        label={t("Others")}
                                        id='othersVal'
                                        checked={othersVal}
                                        onChange={this.handleCheckVal}
                                    />
                                    {
                                        othersVal && <TextField
                                            id='othersInfoVal'
                                            value={othersInfoVal}
                                            onChange={this.handleInputVal}
                                            multiline={2}
                                            autoComplete="off"
                                        />
                                    }
                                </div>
                            </div>
                        </Collapsible>
                    </div>
                    <div className='feedback_two feedback_main'>
                        <p className='fb_items' onClick={() => this.openFeedbackSet(2)}>
                            <span>*</span>
                            <span>{t("Which content we update, would you be willing to choose us again?")}</span>
                            <Icon source={ChevronRightMinor} />
                        </p>
                        <Collapsible
                            open={isShowUpdateSet}
                        >
                            <TextField
                                id='updateFeedback'
                                value={updateFeedback}
                                onChange={this.handleInputVal}
                                multiline={2}
                                autoComplete="off"
                            />
                        </Collapsible>
                    </div>
                </BlockStack>
            </div>
        </Modal>

        // 降级优惠弹窗
        const degradeDiscountModal = <Modal
            open={isShowFiveModal}
            title={<div>
                <span>{t("Special offer")} 👇</span>
            </div>}
            secondaryActions={{
                content: t("Stay"),
                onAction: () => this.openFeedbackModal(true),
            }}
            primaryAction={[
                {
                    content: t("Continue degrade"),
                    onAction: () => this.handleDowngrade(true, true),
                    loading: this.state.paidLoading
                },
            ]}
            onClose={this.openFeedbackModal}
        >
            <div className='degrade_discount modal_padding'>
                <Text variant="headingMd" as="h2">🎁 {t("Discount code")}:【SEOAnt50】</Text>
                <p>
                    {t("We're sorry to hear that you're considering downgrading. We sincerely hope you reconsider, so we've provided you with a special discount code to express our gratitude and sincerity. you can enjoy a")}&nbsp;<span style={{ color: '#7126ed' }}>{t("50%")}</span>&nbsp;{t("discount on all packages. This is our way of expressing apology and hoping you'll continue to choose us.")}
                </p>
            </div>
        </Modal>

        //月费降级到免费弹窗
        const freePlanDegrade = (
            <Modal
                open={openFreePlanDegrade}
                title={t("Degrade warning")}
                onClose={() => { this.setState({ openFreePlanDegrade: !this.state.openFreePlanDegrade }) }}
                secondaryActions={{
                    content: t("Let me think"),
                    onAction: () => { this.setState({ openFreePlanDegrade: !this.state.openFreePlanDegrade }) },
                    disabled: this.state.paidLoading
                }}
                primaryAction={[
                    {
                        content: t("Yes"),
                        onAction: () => { handleDowngrade(true) },
                        loading: this.state.paidLoading
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack>
                        <div className='freePlanDegradeContent'>
                            {/* <Icon source={FreeDegradeWarningIcon} /> */}
                            {
                                userInfo.level === 3 ? <p>{t("If you downgrade, you won't be able to continue using competitor keyword research and AMP functions. Are you sure you want to downgrade?")}</p> : <p>{t("If you downgrade, you'll lose access to features like automatic broken link fixing and image compression. Are you sure you want to downgrade?")}</p>
                            }
                        </div>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )

        // 旧用户一次性付费提示
        const oldPayUserModal = (
            <Modal
                open={oldPayModalStatus}
                title={t("Approve subscription")}
                onClose={() => this.closePayTipModal()}
                primaryAction={{
                    content: t("OK"),
                    onAction: () => this.closePayTipModal(),
                }}
            >
                <Modal.Section>
                    <BlockStack>
                        <p>{t("You are currently subscribed to a paid plan and cannot select a new subscription package for payment. Please first downgrade to a free plan and then select again.")}</p>
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )

        // 底部问答
        // const questionBlock = <Card>
        //     <BlockStack gap={400}>
        //         <BlockStack gap={200}>
        //             <p className='pquestion_title'>{t("How does the Free Trial work?")}</p>
        //             <Text as="p" tone="subdued">{t("You can try SEOAnt for free for 7 days and easily cancel at any time with just one click. If you choose to uninstall or downgrade to the free plan during your trial, you will not be charged.")}</Text>
        //         </BlockStack>
        //         <BlockStack gap={200}>
        //             <p className='pquestion_title'>{t("Can I change my plan in the middle of a billing cycle?")}</p>
        //             <Text as="p" tone="subdued">{t("Yes, you can change your plan anytime based on your needs, the charge is prorated based on the difference in price and the number of days remaining in the billing cycle.")}</Text>
        //         </BlockStack>
        //     </BlockStack>
        // </Card>
        // 常见问题
        const FrequentlyItems = <FaqCardBox FaqList={questionList} />

        // 折扣模块
        const giftDis = <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.9361 1.45423C8.36004 1.0291 9.14023 0.486413 9.80286 0.5541L14.3676 1.0291C15.0302 1.09798 15.624 1.69173 15.624 2.28785L15.9304 6.66974C15.9981 7.33236 15.5741 8.11374 15.0991 8.58993L8.0216 15.6758C7.59648 16.0997 7.00273 16.0997 6.52654 15.6069L0.893029 9.96624C0.418028 9.49124 0.347966 8.94618 0.824154 8.46999L7.90167 1.38535L7.9361 1.45423ZM18.8077 4.89679C19.2197 5.3338 19.5 6.25886 19.5 6.87042L19.3848 17.1209C19.3848 17.7313 18.8564 18.2906 18.2804 18.2906L12.2752 18.3607H11.1044C10.5272 18.3607 9.9988 17.8014 9.9988 17.191L10.0641 15.7755L15.9042 9.59455C16.9599 8.47711 17.1903 7.25517 17.125 6.57236L16.9445 2.92317L18.8077 4.89679ZM11.5687 4.92054C12.0247 5.37773 12.774 5.44305 13.2454 4.98586C13.7014 4.52748 13.6527 3.77461 13.1813 3.30079C12.7253 2.8436 11.976 2.77829 11.5045 3.23548C11.0485 3.71048 11.0972 4.46217 11.5687 4.92054Z" fill="#7126ED" />
        </svg>
        // <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path fillRule="evenodd" clipRule="evenodd" d="M17 3.8291C17 4.38721 16.8972 4.88966 16.6942 5.3291H18.5C19.3284 5.3291 20 6.00067 20 6.8291V9.3291H0V6.8291C0 6.00067 0.671573 5.3291 1.5 5.3291H3.30578C3.10281 4.88966 3 4.38721 3 3.8291C3 1.79972 4.78331 0.329102 6.76923 0.329102C7.93484 0.329102 9.16776 0.874778 10 1.85809C10.8322 0.874778 12.0652 0.329102 13.2308 0.329102C15.2167 0.329102 17 1.79972 17 3.8291ZM5 3.8291C5 3.09182 5.69053 2.3291 6.76923 2.3291C7.81902 2.3291 9 3.19866 9 4.66243V5.3291H8.15385C7.3488 5.3291 6.49776 5.318 5.84848 5.07843C5.54594 4.9668 5.34997 4.82605 5.22697 4.66573C5.1116 4.51535 5 4.26999 5 3.8291ZM11.8462 5.3291H11V4.66243C11 3.19866 12.181 2.3291 13.2308 2.3291C14.3095 2.3291 15 3.09182 15 3.8291C15 4.26999 14.8884 4.51535 14.773 4.66573C14.65 4.82605 14.4541 4.9668 14.1515 5.07843C13.5022 5.318 12.6512 5.3291 11.8462 5.3291Z" fill="#5C5F62"/>
        //     <path d="M9 19.3291V11.3291H1V17.8291C1 18.6591 1.67 19.3291 2.5 19.3291H9Z" fill="#5C5F62"/>
        //     <path d="M11 19.3291V11.3291H19V17.8291C19 18.6591 18.33 19.3291 17.5 19.3291H11Z" fill="#5C5F62"/>
        // </svg>

        const ExclusiveDiscount = <div className='discount_block'>
            <Card>
                <div className='dis_main'>
                    <BlockStack gap={200}>
                        <div className='dis_top'>
                            <span>{giftDis}</span>
                            <Text variant="headingLg" as="h2">{t("Exclusive discount")}</Text>
                        </div>
                        <p>{t("Discount codes can be obtained from partners.")}</p>
                    </BlockStack>
                    <BlockStack gap={400}>
                        <div className='dis_input'>
                            <TextField
                                label=""
                                value={discountVal}
                                onChange={this.handleDiscountChange}
                                autoComplete="off"
                                disabled={iscacheLoading}
                                connectedRight={
                                    <Button variant='primary' loading={disBtnLoading || iscacheLoading} onClick={this.verifyDisCode}>{t("Apply code")}</Button>
                                }
                                focused={codeFocus}
                                error={discountValError}
                            />
                        </div>
                        {
                            isShowDisTicket && <div className='dis_detail'>
                                <div className='dd_left'>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div className='dd_main'>
                                    <div className='dd_dis'>{`${discountRate === 0 ? '100% OFF' : (discountRate > 0 && discountRate < 1) ? (discountRate * 100).toFixed(0) + '% OFF' : '$ ' + discountRate}`}</div>
                                    <div className='dd_plan'>For {discountPlan}</div>
                                    <div className='dd_icon'>
                                        <img src='/Image/discount_img.png' alt='discount_img.png' />
                                    </div>
                                </div>
                                <div className='dd_Right'>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                            </div>
                        }
                    </BlockStack>
                </div>
            </Card>
        </div>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 额外福利弹窗
        const ExtraGiftBox = <Modal
            open={isShowExtraGift}
            title={<div className='flex_layout'>
                {extraIcon} <span style={{ color: '#FC0A0A' }}>{t("Over $100")}</span>&nbsp;{t("extra benefits")}
            </div>}
            primaryAction={userInfo.level !== 3 ? {
                content: t("Upgrade"),
                onAction: () => this.handleUpdatePricingMeal(prePlanId, prePlanPrice, preVersionLevel, { preDiscount, preDiscountPrice, preMonthCountDown, preMonthCountDown_mills, preYearCountDown, preYearCountDown_mills }),
                loading: paidBtnLoading === preVersionLevel,
            } : null}
            onClose={() => {
                this.setState({ isShowExtraGift: false })
            }}
        >
            <Modal.Section>
                <Text variant="headingMd" as="h6">{t("By subscribing to the Pre plan, you can also enjoy a one-month free trial of all the following applications.")}</Text>
                <div id='extra_app_gift'>
                    <BlockStack gap={300}>
                        {
                            Object.keys(appGiftList).map(item => {
                                return <div key={appGiftList[item].title} className='gapp_item'>
                                    <div className='gitem_img'><img src={appGiftList[item].img} alt={appGiftList[item].title} /></div>
                                    <div className='gitem_text'>
                                        <Text variant="headingMd" as="h2">{appGiftList[item].title}</Text>
                                        <p>{appGiftList[item].desc}</p>
                                        <div className='gitem_price'>
                                            <span>$0</span>
                                            <span>${appGiftList[item].price}</span>
                                        </div>
                                    </div>
                                    {
                                        userInfo.level === 3 && <div className='gitem_btn'>
                                            <Tooltip content={t(appGiftList[item].tip)}>
                                                <Button onClick={() => {
                                                    window.open(appGiftList[item].url)
                                                }}>{t("Activate")}</Button>
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                            })
                        }
                    </BlockStack>
                </div>
            </Modal.Section>
        </Modal>

        // cw组合套餐提示弹窗
        const CWComboModal = <Modal
            open={isShowCwComboModal}
            title={t("Plan reminder")}
            primaryAction={{
                content: t("Go to view"),
                onAction: this.goSolutionExpert,
            }}
            secondaryActions={[
                {
                    content: t("Close"),
                    onAction: () => {
                        this.setState({ isShowCwComboModal: false })
                    }
                }
            ]}
            onClose={() => {
                this.setState({ isShowCwComboModal: false })
            }}
        >
            <Modal.Section>
                <p>{t("You are currently using Channelwill's package, please update your plan on the package page")}</p>
            </Modal.Section>
        </Modal>

        // 黑五星星
        // const BlackFriStar = (nums = 5) => {
        //     let StarComponents = <span>
        //         {
        //             [...Array(nums).keys()].map((item) => {
        //                 return <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" key={`Star-${item}`}>
        //                     <path d="M6.75944 10.6906L9.72623 12.5702C10.1054 12.8105 10.5763 12.4532 10.4637 12.0105L9.60661 8.63858C9.58251 8.54465 9.58533 8.44582 9.61489 8.3535C9.64435 8.26113 9.69941 8.17897 9.77348 8.11648L12.434 5.90216C12.7835 5.61121 12.6031 5.03106 12.154 5.00191L8.67964 4.77642C8.58609 4.76974 8.4963 4.7366 8.42082 4.68088C8.34533 4.62516 8.28723 4.54915 8.25328 4.46168L6.9575 1.19857C6.92227 1.10573 6.85964 1.02581 6.77792 0.96941C6.69621 0.913015 6.59926 0.882812 6.49997 0.882812C6.40069 0.882812 6.30374 0.913015 6.22202 0.96941C6.14031 1.02581 6.07767 1.10573 6.04245 1.19857L4.74667 4.46168C4.71271 4.54915 4.65461 4.62516 4.57914 4.68088C4.50366 4.7366 4.4139 4.76974 4.32032 4.77642L0.845975 5.00191C0.396855 5.03106 0.216422 5.61121 0.565994 5.90216L3.22642 8.11648C3.30056 8.17897 3.35556 8.26113 3.38509 8.3535C3.41462 8.44582 3.41748 8.54465 3.39334 8.63858L2.59841 11.7656C2.46337 12.2968 3.02837 12.7256 3.48345 12.4374L6.2405 10.6906C6.31804 10.6412 6.40806 10.615 6.49997 10.615C6.5919 10.615 6.6819 10.6412 6.75944 10.6906Z" fill="#11A75C" />
        //                 </svg>
        //             })
        //         }
        //     </span>
        //     return StarComponents;
        // }

        // 是否内嵌
        const isShopify = this.props.public.isShowTopMenu || 1;

        // 最终内容
        let pageContentLast = (this.state.loadingPage || diyBannerState === -1 || isActLoading) ? <SkeltonLoading /> :
            <Page
                title={Boolean(isShopify) ? <div className='flex_layout'>
                    <span>{t("Pricing")}</span>
                    {/* 旧版价格 */}
                    {Boolean(old_button) ? <div className='pricing-box oldversion-pricing-ssss' onClick={() => {
                        utils.routeJump(this, "/oldversion/pricing")
                    }}>
                        <Button>{t("Switch to the old version")}</Button>
                    </div> : null}
                </div> : null}
            >
                <title>SEOAnt - Pricing</title>

                {/* 年月费Tab */}
                {TabPlansBlock}

                {
                    (Boolean(planName && planName.includes('新用户首次')) && !isShowCouponDis && diyBannerState) ? (
                        <div className='pricing_top_banner'>
                            <img src={'/user_guide/time_banner.png?v=12306'} alt='discount-banner' />
                            <div className='dis_banner_time'>
                                <div className='time_items'>
                                    <p className='time_val'>{cDays}</p>
                                    <span className='time_unit'>DAYS</span>
                                </div>
                                <div className='time_items'>
                                    <p className='time_val'>{cHours}</p>
                                    <span className='time_unit'>HOURS</span>
                                </div>
                                <div className='time_items'>
                                    <p className='time_val'>{cMins}</p>
                                    <span className='time_unit'>MINS</span>
                                </div>
                                <div className='time_items'>
                                    <p className='time_val'>{cSecs}</p>
                                    <span className='time_unit'>SECS</span>
                                </div>
                            </div>
                            <div className='close-time-banner' onClick={this.closeTimeBanner}><Icon source={CancelMajor} /></div>
                        </div>
                    ) : null
                }
                <div className={`pricing_main newLayoutPricing`}>
                    {/* {pricingTab} */}
                    <div style={{ marginTop: this.state.level === 1 ? '1.5rem' : (![8, 9].includes(userInfo.ppid) ? '1.5rem' : '3rem') }}></div>
                    <BlockStack gap={400}>
                        {pricingMealContent}
                        {/* {ExpertServiceBlock} */}
                        {integralBox}
                        {pricingDetailBtn}
                        {userReviewBox}
                        {/* {questionBlock} */}
                        {FrequentlyItems}
                        {ExclusiveDiscount}
                    </BlockStack>
                </div>
                {/* 升降级弹窗 */}
                {pageModal}
                {/* 降级弹窗 */}
                {freePlanDegrade}
                {degradeDiscountModal}
                {feedbackModal}
                {/* 一次性付费提示 */}
                {oldPayUserModal}
                {/* 底部 */}
                {FooterHelpBox}
                {/* 福利弹窗 */}
                {ExtraGiftBox}
                {/* cw支付提示 */}
                {CWComboModal}
            </Page>

        return (
            <div className='Pricing' style={{ position: 'relative' }}>
                {pageContentLast}
            </div>
        );
    }

}

function getCookie(cookieName) {
    //获取所有的cookie "psw=1234we; rememberme=true; user=Annie"
    var totalCookie = document.cookie;
    //获取参数所在的位置
    var cookieStartAt = totalCookie.indexOf(cookieName + "=");
    //判断参数是否存在 不存在直接返回
    if (cookieStartAt === -1) {
        return;
    }
    //获取参数值的开始位置
    var valueStartAt = totalCookie.indexOf("=", cookieStartAt) + 1;
    //以;来获取参数值的结束位置
    var valueEndAt = totalCookie.indexOf(";", cookieStartAt);
    //如果没有;则是最后一位
    if (valueEndAt === -1) {
        valueEndAt = totalCookie.length;
    }
    //截取参数值的字符串
    var cookieValue = unescape(totalCookie.substring(valueStartAt, valueEndAt));
    return cookieValue;
}

// 格式化时间戳
function formatUSATime(time) {
    // 创建一个新的 Date 对象，传入时间戳（秒为单位）
    var date = new Date(time * 1000);

    // 定义月份名称
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // 提取年、月、日、小时、分钟、上午/下午
    var year = date.getFullYear();
    var month = monthNames[date.getMonth()];
    var day = date.getDate();
    // var hours = date.getHours();
    // var minutes = date.getMinutes();
    // var ampm = hours >= 12 ? 'pm' : 'am';

    // 将小时调整为 12 小时制
    // hours = hours % 12;
    // hours = hours ? hours : 12; // 如果 hours 为 0，则设为 12

    // 格式化分钟数为两位数
    // minutes = minutes < 10 ? '0' + minutes : minutes;

    // 组合成指定格式的字符串
    var formattedDate = t(month) + ' ' + (day < 10 ? '0' + day : day) + ', ' + year;
    return formattedDate;
}

const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['pricingPlan', data]));
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

    // 调用派遣 异步请求公共数据
    getPublicDataRedux(res) {
        // dispatch(fetchPublicData());
        dispatch(setPublicData(res));
    },
})

Pricing = connect(
    mapStateToProps,
    mapDispatchToProps
)(Pricing);

export default withRouter(Pricing);